import BranchDetailPage from './BranchDetailPage';
import BedtimeStory1 from './BedtimeStory1';
import BedtimeStory2 from './BedtimeStory2';
import BedtimeStory3 from './BedtimeStory3';
import OutdoorRunPage from './OutdoorRunPage';
import OutdoorRunSession1 from './OutdoorRunSession1';
import OutdoorRunSession2 from './OutdoorRunSession2';
import OutdoorRunSession3 from './OutdoorRunSession3';
import SleepingMeditationPage from './SleepingMeditationPage';
import SleepingMeditationSession1 from './SleepingMeditationSession1';
import SleepingMeditationSession2 from './SleepingMeditationSession2';
import SleepingMeditationSession3 from './SleepingMeditationSession3';
import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import ThemeToggle from '../components/ThemeToggle';
import Modal from '../components/Modal';
import { API_CONFIG } from '../config/api';
import LearnPage from './LearnPage';
import AssessmentsPage from './AssessmentsPage';
import GroundWorkPage from './GroundWorkPage';
import ChatPage from './ChatPage';
import ProfilePage from './ProfilePage';
import SubscriptionPage from './SubscriptionPage';
import BillingHistoryPage from './BillingHistoryPage';
import SubscriptionPlansPage from './SubscriptionPlansPage';
import SubscriptionPlanEditPage from './SubscriptionPlanEditPage';
import SubscriberManagementPage from './SubscriberManagementPage';
import SubscriberDetailPage from './SubscriberDetailPage';
import EditUserPage from './EditUserPage';
import PaymentSetupPage from './PaymentSetupPage';
import WellnessPage from './WellnessPage';
import WellnessLoopPage from './WellnessLoopPage';
import SpiritualResourcesPage from './SpiritualResourcesPage';
import NutritionalResourcesPage from './NutritionalResourcesPage';
import EmotioPsychoRationalResourcesPage from './EmotioPsychoRationalResourcesPage';
import DashboardPage from './DashboardPage';
import ConsultationsPage from './ConsultationsPage';
import ConsultantDashboardPage from './ConsultantDashboardPage';
import ConsultantVulnerabilitiesPage from './ConsultantVulnerabilitiesPage';
import ConsultantOverviewPage from './ConsultantOverviewPage';
import ConsultantReportsPage from './ConsultantReportsPage';
import ConsultantUsersPage from './ConsultantUsersPage';
import ConsultantGroupDetailsPage from './ConsultantGroupDetailsPage';
import ConsultantGroupWorkspacePage from './ConsultantGroupWorkspacePage';
import ConsultantEnterpriseGroupsPage from './ConsultantEnterpriseGroupsPage';
import ConsultantSowbBreakdownPage from './ConsultantSowbBreakdownPage';
import EnterpriseDashboardPage from './EnterpriseDashboardPage';
import EnterpriseVulnerabilitiesPage from './EnterpriseVulnerabilitiesPage';
import EnterpriseOverviewPage from './EnterpriseOverviewPage';
import EnterpriseReportsPage from './EnterpriseReportsPage';
import EnterpriseSowbBreakdownPage from './EnterpriseSowbBreakdownPage';
import EnterpriseGroupsPage from './EnterpriseGroupsPage';
import EnterpriseGroupEditPage from './EnterpriseGroupEditPage';
import EnterpriseGroupCreationPage from './EnterpriseGroupCreationPage';
import EnterpriseConsolidationPage from './EnterpriseConsolidationPage';
import ConsultantUserTPage from './ConsultantUserTPage';
import ConsultantThemePage from './ConsultantThemePage';
import ConsultantProfilePage from './ConsultantProfilePage';
import UserDetailedProfilePage from './UserDetailedProfilePage';
import ConsultantWellnessCreationPage from './ConsultantWellnessCreationPage';
import ConsultantWellnessPage from './ConsultantWellnessPage';
import ConsultantWellnessModuleCreationPage from './ConsultantWellnessModuleCreationPage';
import ConsultantWellnessSessionCreationPage from './ConsultantWellnessSessionCreationPage';
import GroupListPage from './GroupListPage';
import AdminDashboardPage from './AdminDashboardPage';
import AdminSuggestionsPage from './AdminSuggestionsPage';
import BloodTestInputPage from './BloodTestInputPage';
import SpiritualAssessmentFormPage from './SpiritualAssessmentFormPage';
import SpiritualModule1Page from './SpiritualModule1Page';
import SpiritualModule2Page from './SpiritualModule2Page';
import SpiritualModule3Page from './SpiritualModule3Page';
import SpiritualModule4Page from './SpiritualModule4Page';
import SpiritualModule5Page from './SpiritualModule5Page';
import SpiritualModule6Page from './SpiritualModule6Page';
import SpiritualModule7Page from './SpiritualModule7Page';
import SpiritualModule1QuizPage from './SpiritualModule1QuizPage';
import SpiritualModule2QuizPage from './SpiritualModule2QuizPage';
import SpiritualModule3QuizPage from './SpiritualModule3QuizPage';
import SpiritualModule4QuizPage from './SpiritualModule4QuizPage';
import SpiritualModule5QuizPage from './SpiritualModule5QuizPage';
import SpiritualModule6QuizPage from './SpiritualModule6QuizPage';
import SpiritualModule7QuizPage from './SpiritualModule7QuizPage';
import NutritionalModule1Page from './NutritionalModule1Page';
import NutritionalModule2Page from './NutritionalModule2Page';
import NutritionalModule3Page from './NutritionalModule3Page';
import NutritionalModule4Page from './NutritionalModule4Page';
import NutritionalModule5Page from './NutritionalModule5Page';
import NutritionalModule6Page from './NutritionalModule6Page';
import NutritionalModule1QuizPage from './NutritionalModule1QuizPage';
import NutritionalModule2QuizPage from './NutritionalModule2QuizPage';
import NutritionalModule3QuizPage from './NutritionalModule3QuizPage';
import NutritionalModule4QuizPage from './NutritionalModule4QuizPage';
import NutritionalModule5QuizPage from './NutritionalModule5QuizPage';
import NutritionalModule6QuizPage from './NutritionalModule6QuizPage';
import NutritionalAssessmentFormPage from './NutritionalAssessmentFormPage';
import EmotioPsychoRationalAssessmentFormPage from './EmotioPsychoRationalAssessmentFormPage';
import EmotioPsychoRationalModule1Page from './EmotioPsychoRationalModule1Page';
import EmotioPsychoRationalModule2Page from './EmotioPsychoRationalModule2Page';
import EmotioPsychoRationalModule3Page from './EmotioPsychoRationalModule3Page';
import EmotioPsychoRationalModule4Page from './EmotioPsychoRationalModule4Page';
import EmotioPsychoRationalModule5Page from './EmotioPsychoRationalModule5Page';
import EmotioPsychoRationalModule1QuizPage from './EmotioPsychoRationalModule1QuizPage';
import EmotioPsychoRationalModule2QuizPage from './EmotioPsychoRationalModule2QuizPage';
import EmotioPsychoRationalModule3QuizPage from './EmotioPsychoRationalModule3QuizPage';
import EmotioPsychoRationalModule4QuizPage from './EmotioPsychoRationalModule4QuizPage';
import EmotioPsychoRationalModule5QuizPage from './EmotioPsychoRationalModule5QuizPage';
import LegendarialAssessmentFormPage from './LegendarialAssessmentFormPage';
import ReligioTraditioCulturalAssessmentFormPage from './ReligioTraditioCulturalAssessmentFormPage';
import SocioRelationalAssessmentFormPage from './SocioRelationalAssessmentFormPage';
import FinancialAssessmentFormPage from './FinancialAssessmentFormPage';
import EnvironmentalAssessmentFormPage from './EnvironmentalAssessmentFormPage';
import OccupationalAssessmentFormPage from './OccupationalAssessmentFormPage';
import SpiritualAssessmentCompletionPage from './SpiritualAssessmentCompletionPage';
import NutritionalAssessmentCompletionPage from './NutritionalAssessmentCompletionPage';
import EmotioPsychoRationalAssessmentCompletionPage from './EmotioPsychoRationalAssessmentCompletionPage';
import LegendarialAssessmentCompletionPage from './LegendarialAssessmentCompletionPage';
import ReligioTraditioCulturalAssessmentCompletionPage from './ReligioTraditioCulturalAssessmentCompletionPage';
import SocioRelationalAssessmentCompletionPage from './SocioRelationalAssessmentCompletionPage';
import FinancialAssessmentCompletionPage from './FinancialAssessmentCompletionPage';
import EnvironmentalAssessmentCompletionPage from './EnvironmentalAssessmentCompletionPage';
import OccupationalAssessmentCompletionPage from './OccupationalAssessmentCompletionPage';
import PhysicalWellnessLearnAssessmentPage from './PhysicalWellnessLearnAssessmentPage';
import PhysicalWellnessLearnAssessmentCompletionPage from './PhysicalWellnessLearnAssessmentCompletionPage';
import GeneralPhysicalAssessmentCompletionPage from './GeneralPhysicalAssessmentCompletionPage';
import IPAQSFAssessmentCompletionPage from './IPAQSFAssessmentCompletionPage';
import PSQIAssessmentCompletionPage from './PSQIAssessmentCompletionPage';
import PhysicalResourcesPage from './PhysicalResourcesPage';
import PhysicalModule1Page from './PhysicalModule1Page';
import PhysicalModule2Page from './PhysicalModule2Page';
import PhysicalModule3Page from './PhysicalModule3Page';
import PhysicalModule1QuizPage from './PhysicalModule1QuizPage';
import PhysicalModule2QuizPage from './PhysicalModule2QuizPage';
import PhysicalModule3QuizPage from './PhysicalModule3QuizPage';
import InsightsPage from './InsightsPage';
import DataPermissionsPage from './DataPermissionsPage';
import DassPage from './DassPage';
import DassAssessmentPage from './DassAssessmentPage';
import StarOfWellbeingCompletion from './StarOfWellbeingCompletion';
import StarOfWellBeingDetailsPage from './StarOfWellBeingDetailsPage';
import { AudioProvider } from './DassPage';
import LogoImgtxt from '../assets/magiteque-logo-text.png';
import LogoSmall from '../assets/magitequeicon.webp';
import MorningMeditationPage from './MorningMeditationPage';
import YogaFlowPage from './YogaFlowPage';
import YogaFlowSession1 from './YogaFlowSession1';
import YogaFlowSession2 from './YogaFlowSession2';
import YogaFlowSession3 from './YogaFlowSession3';
import YogaFlowSession4 from './YogaFlowSession4';
import YogaFlowSession5 from './YogaFlowSession5';
import MorningMeditationSession1 from './MorningMeditationSession1';
import MorningMeditationSession2 from './MorningMeditationSession2';
import MorningMeditationSession3 from './MorningMeditationSession3';
import WellnessSessionDetailPage from './WellnessSessionDetailPage';
import {
  Lightbulb,
  MessageCircle,
  Heart,
  BookOpen,
  Video,
  User,
  Users,
  Settings,
  LayoutDashboard,
  Activity,
  X,
  Shield,
  BarChart3,
  FileText,
  UserCog,
  Palette,
  Building,
  MessageSquare
} from 'lucide-react';
import OccupationalResourcesPage from './OccupationalResourcesPage';
import OccupationalModule1Page from './OccupationalModule1Page';
import OccupationalModule2Page from './OccupationalModule2Page';
import OccupationalModule3Page from './OccupationalModule3Page';
import OccupationalModule4Page from './OccupationalModule4Page';
import OccupationalModule5Page from './OccupationalModule5Page';
import OccupationalModule1QuizPage from './OccupationalModule1QuizPage';
import OccupationalModule2QuizPage from './OccupationalModule2QuizPage';
import OccupationalModule3QuizPage from './OccupationalModule3QuizPage';
import OccupationalModule4QuizPage from './OccupationalModule4QuizPage';
import OccupationalModule5QuizPage from './OccupationalModule5QuizPage';
import LegendarialResourcesPage from './LegendarialResourcesPage';
import LegendarialModule1Page from './LegendarialModule1Page';
import LegendarialModule2Page from './LegendarialModule2Page';
import LegendarialModule3Page from './LegendarialModule3Page';
import LegendarialModule4Page from './LegendarialModule4Page';
import LegendarialModule5Page from './LegendarialModule5Page';
import LegendarialModule1QuizPage from './LegendarialModule1QuizPage';
import LegendarialModule2QuizPage from './LegendarialModule2QuizPage';
import LegendarialModule3QuizPage from './LegendarialModule3QuizPage';
import LegendarialModule4QuizPage from './LegendarialModule4QuizPage';
import LegendarialModule5QuizPage from './LegendarialModule5QuizPage';
import ReligioTraditioCulturalResourcesPage from './ReligioTraditioCulturalResourcesPage';
import ReligioTraditioCulturalModule1Page from './ReligioTraditioCulturalModule1Page';
import ReligioTraditioCulturalModule2Page from './ReligioTraditioCulturalModule2Page';
import ReligioTraditioCulturalModule3Page from './ReligioTraditioCulturalModule3Page';
import ReligioTraditioCulturalModule4Page from './ReligioTraditioCulturalModule4Page';
import ReligioTraditioCulturalModule5Page from './ReligioTraditioCulturalModule5Page';
import ReligioTraditioCulturalModule6Page from './ReligioTraditioCulturalModule6Page';
import ReligioTraditioCulturalModule1QuizPage from './ReligioTraditioCulturalModule1QuizPage';
import ReligioTraditioCulturalModule2QuizPage from './ReligioTraditioCulturalModule2QuizPage';
import ReligioTraditioCulturalModule3QuizPage from './ReligioTraditioCulturalModule3QuizPage';
import ReligioTraditioCulturalModule4QuizPage from './ReligioTraditioCulturalModule4QuizPage';
import ReligioTraditioCulturalModule5QuizPage from './ReligioTraditioCulturalModule5QuizPage';
import ReligioTraditioCulturalModule6QuizPage from './ReligioTraditioCulturalModule6QuizPage';
import SocioRelationalResourcesPage from './SocioRelationalResourcesPage';
import SocioRelationalModule1Page from './SocioRelationalModule1Page';
import SocioRelationalModule2Page from './SocioRelationalModule2Page';
import SocioRelationalModule3Page from './SocioRelationalModule3Page';
import SocioRelationalModule4Page from './SocioRelationalModule4Page';
import SocioRelationalModule5Page from './SocioRelationalModule5Page';
import SocioRelationalModule1QuizPage from './SocioRelationalModule1QuizPage';
import SocioRelationalModule2QuizPage from './SocioRelationalModule2QuizPage';
import SocioRelationalModule3QuizPage from './SocioRelationalModule3QuizPage';
import SocioRelationalModule4QuizPage from './SocioRelationalModule4QuizPage';
import SocioRelationalModule5QuizPage from './SocioRelationalModule5QuizPage';
import FinancialResourcesPage from './FinancialResourcesPage';
import FinancialModule1Page from './FinancialModule1Page';
import FinancialModule2Page from './FinancialModule2Page';
import FinancialModule3Page from './FinancialModule3Page';
import FinancialModule4Page from './FinancialModule4Page';
import FinancialModule5Page from './FinancialModule5Page';
import FinancialModule1QuizPage from './FinancialModule1QuizPage';
import FinancialModule2QuizPage from './FinancialModule2QuizPage';
import FinancialModule3QuizPage from './FinancialModule3QuizPage';
import FinancialModule4QuizPage from './FinancialModule4QuizPage';
import FinancialModule5QuizPage from './FinancialModule5QuizPage';
import EnvironmentalResourcesPage from './EnvironmentalResourcesPage';
import EnvironmentalModule1Page from './EnvironmentalModule1Page';
import EnvironmentalModule2Page from './EnvironmentalModule2Page';
import EnvironmentalModule3Page from './EnvironmentalModule3Page';
import EnvironmentalModule4Page from './EnvironmentalModule4Page';
import EnvironmentalModule5Page from './EnvironmentalModule5Page';
import EnvironmentalModule6Page from './EnvironmentalModule6Page';
import EnvironmentalModule1QuizPage from './EnvironmentalModule1QuizPage';
import EnvironmentalModule2QuizPage from './EnvironmentalModule2QuizPage';
import EnvironmentalModule3QuizPage from './EnvironmentalModule3QuizPage';
import EnvironmentalModule4QuizPage from './EnvironmentalModule4QuizPage';
import EnvironmentalModule5QuizPage from './EnvironmentalModule5QuizPage';
import EnvironmentalModule6QuizPage from './EnvironmentalModule6QuizPage';
import HealthyEatingHabitsPage from './HealthyEatingHabitsPage';
import HealthyEatingModule1Page from './HealthyEatingModule1Page';
import HealthyEatingModule2Page from './HealthyEatingModule2Page';
import HealthyEatingModule3Page from './HealthyEatingModule3Page';
import HealthyEatingModule4Page from './HealthyEatingModule4Page';
import FinancialPlanningResourcePage from './FinancialPlanningResourcePage';
import FinancialPlanningModule1Page from './FinancialPlanningModule1Page';
import FinancialPlanningModule2Page from './FinancialPlanningModule2Page';
import FinancialPlanningModule3Page from './FinancialPlanningModule3Page';
import EnterpriseProfilePage from './EnterpriseProfilePage';

type DashboardMode = 'user' | 'consultant' | 'enterprise' | 'admin';
type RoleName = 'Admin' | 'Consultant' | 'Enterprise' | 'User';
type RoleAccess = { allowedModes: DashboardMode[]; defaultMode: DashboardMode };

// Role-based access mapping
const ROLE_ACCESS_MAP: Record<RoleName, RoleAccess> = {
  Admin: { allowedModes: ['user', 'consultant', 'enterprise', 'admin'], defaultMode: 'admin' },
  Consultant: { allowedModes: ['consultant', 'user'], defaultMode: 'consultant' },
  Enterprise: { allowedModes: ['enterprise', 'user'], defaultMode: 'enterprise' },
  User: { allowedModes: ['user'], defaultMode: 'user' },
};

// Helper function to get role access info (case-insensitive + safe fallback)
const getRoleAccess = (role?: string): RoleAccess => {
  const normalized = (role || 'User').toLowerCase();
  if (normalized === 'admin') return ROLE_ACCESS_MAP.Admin;
  if (normalized === 'consultant') return ROLE_ACCESS_MAP.Consultant;
  if (normalized === 'enterprise') return ROLE_ACCESS_MAP.Enterprise;
  return ROLE_ACCESS_MAP.User;
};

// Navigation configuration for different dashboard modes
const NAV_BY_MODE = {
  user: [
    { to: '/panel/dashboard', icon: LayoutDashboard, label: 'Dashboard', end: true },
    { to: '/panel/chat', icon: MessageCircle, label: 'Chat' },
    { to: '/panel/wellness', icon: Heart, label: 'Wellness' },
    { to: '/panel/wellness-loop', icon: Activity, label: 'Wellness Loop' },
    { to: '/panel/learn', icon: BookOpen, label: 'Learn' },
    { to: '/panel/insights', icon: Lightbulb, label: 'Insights' },
    { to: '/panel/consultations', icon: Video, label: 'Consultations' },
    { to: '/panel/group-list', icon: Users, label: 'Group List' },
  ],
  consultant: [
    { to: '/panel/consultant', icon: LayoutDashboard, label: 'C-Dashboard', end: true },
    { to: '/panel/consultant/vulnerabilities', icon: Shield, label: 'Vulnerabilities' },
    { to: '/panel/consultant/overview', icon: BarChart3, label: 'Overview' },
    { to: '/panel/consultant/reports', icon: FileText, label: 'Reports' },
    { to: '/panel/consultant/users', icon: Users, label: 'Users' },
    { to: '/panel/consultant/group-creation', icon: UserCog, label: 'Group Creation' },
    { to: '/panel/consultant/enterprise-groups', icon: Building, label: 'Enterprise Groups' },
    {
      icon: Activity,
      label: 'Wellness',
      submenu: [
        { to: '/panel/consultant/wellness', label: 'All Modules & Sessions' },
        { to: '/panel/consultant/wellness-module-creation', label: 'Create Module' },
        { to: '/panel/consultant/wellness-session-creation', label: 'Create Session' },
      ],
    },
    { to: '/panel/consultant/profile', icon: User, label: 'Profile' },
    { to: '/panel/consultant/sowb-breakdown', icon: BarChart3, label: 'SOWB Breakdown' },
  ],
  enterprise: [
    { to: '/panel/enterprise', icon: LayoutDashboard, label: 'E-Dashboard', end: true },
    { to: '/panel/enterprise/vulnerabilities', icon: Shield, label: 'Vulnerabilities' },
    { to: '/panel/enterprise/overview', icon: BarChart3, label: 'Overview' },
    { to: '/panel/enterprise/reports', icon: FileText, label: 'Reports' },
    { to: '/panel/enterprise/sowb-breakdown', icon: BarChart3, label: 'SOWB Breakdown' },
    { to: '/panel/enterprise/users', icon: Users, label: 'Users' },
    { to: '/panel/enterprise/groups', icon: Users, label: 'Groups' },
    { to: '/panel/enterprise/group-creation', icon: UserCog, label: 'Group Creation' },
    { to: '/panel/enterprise/management', icon: Building, label: 'Branch Management' },
  ],
  admin: [
    { to: '/panel/admin', icon: LayoutDashboard, label: 'A-Dashboard', end: true },
    { to: '/panel/admin/subscriber-management', icon: Users, label: 'Subscriber Management' },
    { to: '/panel/admin/subscription-plans', icon: Settings, label: 'Subscription Plans' },
    { to: '/panel/admin/suggestions', icon: MessageSquare, label: 'Suggestions' },
    { to: '/panel/admin/theme', icon: Palette, label: 'Theme' },
  ],
};

const Panel: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { isDarkMode } = useTheme();
  const [isDeveloper, setIsDeveloper] = useState(false); // Default to user mode
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [dashboardMode, setDashboardMode] = useState<DashboardMode>('user');
  const [openSubmenus, setOpenSubmenus] = useState<Set<string>>(new Set());

  // Subscription and access control state
  const [allowedUserNav, setAllowedUserNav] = useState<string[]>(['/panel/dashboard']);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const profileMenuRef = useRef<HTMLDivElement>(null);
  const profileBtnRef = useRef<HTMLButtonElement>(null);
  const mobileProfileMenuRef = useRef<HTMLDivElement>(null);
  const mobileProfileBtnRef = useRef<HTMLButtonElement>(null);

  // Fetch user subscription and set access permissions
  const fetchUserSubscription = async () => {
    try {
      // If admin, grant all access
      if (user?.role && user.role.toLowerCase() === 'admin') {
        setAllowedUserNav(NAV_BY_MODE.user.map(item => item.to));
        return;
      }
      const response = await fetch(`${API_CONFIG.ENDPOINTS.BILLING_SUBSCRIPTION}/me?t=${Date.now()}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const result = await response.json();
        if (result.success && result.data) {
          // Extract allowed navigation from plan metadata
          const planAccess = result.data.subscription?.plan?.metadata?.access?.userNav;
          if (planAccess && planAccess.length > 0) {
            // Convert simple keys to full panel routes (e.g., 'dashboard' → '/panel/dashboard')
            const fullPaths = planAccess.map((key: string) => 
              key.startsWith('/') ? key : `/panel/${key}`
            );
            setAllowedUserNav(fullPaths);
          } else {
            setAllowedUserNav(['/panel/dashboard']);
          }
        } else {
          // No subscription, default to dashboard only
          setAllowedUserNav(['/panel/dashboard']);
        }
      } else if (response.status === 404) {
        // No subscription found
        setAllowedUserNav(['/panel/dashboard']);
      }
    } catch (error) {
      console.error('Error fetching subscription:', error);
      // On error, default to dashboard only
      setAllowedUserNav(['/panel/dashboard']);
    }
  };

  // Check if we're on routes that should hide sidebar (assessment pages)
  const shouldHideSidebar = location.pathname === '/panel/wellness/dass' ||
                           location.pathname === '/panel/wellness/dass/assessment' ||
                           location.pathname === '/panel/star-of-wellbeing/assessment/completion';

  // Handle outside click and escape key for profile menu
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isProfileMenuOpen) {
        const target = event.target as Node;
        const isOutsideDesktopMenu = profileMenuRef.current && !profileMenuRef.current.contains(target) && profileBtnRef.current && !profileBtnRef.current.contains(target);
        const isOutsideMobileMenu = mobileProfileMenuRef.current && !mobileProfileMenuRef.current.contains(target) && mobileProfileBtnRef.current && !mobileProfileBtnRef.current.contains(target);

        if (isOutsideDesktopMenu && isOutsideMobileMenu) {
          setIsProfileMenuOpen(false);
        }
      }
    };

    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isProfileMenuOpen) {
        setIsProfileMenuOpen(false);
        profileBtnRef.current?.focus();
      }
    };

    if (isProfileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isProfileMenuOpen]);

  // Close profile menu when location changes (when navigating)
  useEffect(() => {
    setIsProfileMenuOpen(false);
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  // Close profile menu when sidebar closes
  useEffect(() => {
    if (!isMobileMenuOpen) {
      setIsProfileMenuOpen(false);
    }
  }, [isMobileMenuOpen]);

  // Close profile menu when sidebar hides
  useEffect(() => {
    setIsProfileMenuOpen(false);
  }, [shouldHideSidebar]);

  // Close menus on window resize (when switching between mobile/desktop)
  useEffect(() => {
    const handleResize = () => {
      setIsProfileMenuOpen(false);
      setIsMobileMenuOpen(false);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch user subscription on mount and when user changes
  useEffect(() => {
    if (user && dashboardMode === 'user') {
      fetchUserSubscription();
    }
  }, [user, dashboardMode]);

  // Get current user's allowed modes and default mode
  const userRoleAccess = getRoleAccess(user?.role);
  const allowedModes = userRoleAccess.allowedModes;
  const defaultMode = userRoleAccess.defaultMode;

  // Route guard and dashboard mode sync
  useEffect(() => {
    let targetMode: DashboardMode = 'user';

    // Determine target mode from URL
    if (location.pathname.startsWith('/panel/admin')) {
      targetMode = 'admin';
    } else if (location.pathname.startsWith('/panel/enterprise')) {
      targetMode = 'enterprise';
    } else if (location.pathname.startsWith('/panel/consultant')) {
      targetMode = 'consultant';
    } else {
      targetMode = 'user';
    }

    // Check if user has access to this mode
    if (!allowedModes.includes(targetMode)) {
      // User doesn't have access, redirect to their default allowed mode
      const redirectPath = defaultMode === 'admin' ? '/panel/admin' :
                          defaultMode === 'consultant' ? '/panel/consultant' :
                          defaultMode === 'enterprise' ? '/panel/enterprise' :
                          '/panel/dashboard';
      navigate(redirectPath, { replace: true });
      return;
    }

    // User has access, set the dashboard mode
    setDashboardMode(targetMode);
  }, [location.pathname, user?.role, allowedModes, navigate]);

  // Route guard for user panel access control
  useEffect(() => {
    if (dashboardMode === 'user' && !shouldHideSidebar) {
      // Check if current path is a user sidebar route that should be blocked
      const userNavRoutes = NAV_BY_MODE.user.map(item => item.to);
      const currentPath = location.pathname;

      // Check if this is a user sidebar route
      const isUserSidebarRoute = userNavRoutes.some(route => {
        if (route === '/panel/dashboard' && (currentPath === '/panel' || currentPath === '/panel/dashboard')) return true;
        return currentPath === route || currentPath.startsWith(route + '/');
      });

      if (isUserSidebarRoute && !allowedUserNav.includes(currentPath.split('/')[2] ? `/panel/${currentPath.split('/')[2]}` : '/panel/dashboard')) {
        // User is trying to access a blocked route via URL, redirect without modal
        navigate('/panel/dashboard', { replace: true });
      }
    }
  }, [location.pathname, dashboardMode, allowedUserNav, shouldHideSidebar, navigate, defaultMode]);

  // Helper function to check if current path matches nav item (including parent routes)
  const isNavItemActive = (navPath: string, isEnd?: boolean): boolean => {
    const currentPath = location.pathname;
    
    if (isEnd) {
      // Exact match for items with end: true
      return currentPath === navPath;
    }
    
    // Special handling for parent menu items with child/detail pages
    const parentChildMappings: Record<string, string[]> = {
      // Consultant section
      '/panel/consultant': ['/panel/consultant/user/'],
      '/panel/consultant/group-creation': ['/panel/consultant/group-creation/group/'],
      '/panel/consultant/enterprise-groups': ['/panel/consultant/enterprise-groups/'],
      
      // Enterprise section
      '/panel/enterprise': ['/panel/enterprise/user/'],
      '/panel/enterprise/users': ['/panel/enterprise/user/'],
      '/panel/enterprise/groups': ['/panel/enterprise/groups/'],
      '/panel/enterprise/management': [
        '/panel/enterprise/management/',
        '/panel/enterprise/branch/',
        '/panel/enterprise/profile/'
      ],
      
      // Admin section
      '/panel/admin/subscriber-management': [
        '/panel/admin/subscriber-management/',
      ],
      '/panel/admin/subscription-plans': [
        '/panel/admin/subscription-plans/edit/'
      ],
      
      // Dashboard/User section
      '/panel/dashboard': [
        '/panel/dashboard/morning-meditation',
        '/panel/dashboard/sleeping-meditation'
      ],
    };
    
    // Check if this path has child routes
    if (parentChildMappings[navPath]) {
      const childPatterns = parentChildMappings[navPath];
      const isParent = currentPath === navPath || 
                       currentPath.startsWith(navPath + '/') ||
                       childPatterns.some(pattern => currentPath.startsWith(pattern));
      if (isParent) return true;
    }
    
    // Default: match if current path matches exactly or starts with nav path
    return currentPath === navPath || currentPath.startsWith(navPath + '/');
  };

  // Helper function to render navigation items
  const renderNavItems = (mode: keyof typeof NAV_BY_MODE, isMobile = false) => {
    const navItems = NAV_BY_MODE[mode];
    if (!navItems) return null;

    return navItems.map((item, index) => {
      // Check if this item has a submenu
      const hasSubmenu = 'submenu' in item && item.submenu;
      const IconComponent = item.icon;
      const submenuKey = `${mode}-${index}`;
      const isSubmenuOpen = openSubmenus.has(submenuKey);

      if (hasSubmenu) {
        // Render submenu item
        const handleSubmenuToggle = () => {
          const newSubmenus = new Set(openSubmenus);
          if (newSubmenus.has(submenuKey)) {
            newSubmenus.delete(submenuKey);
          } else {
            newSubmenus.add(submenuKey);
          }
          setOpenSubmenus(newSubmenus);
        };

        const submenuItems = item.submenu || [];
        const isSubmenuActive = submenuItems.some(subitem => 
          location.pathname === subitem.to || location.pathname.startsWith(subitem.to + '/')
        );

        return (
          <div key={`submenu-${index}`} className="nav-submenu-container">
            <button
              className={`nav-submenu-toggle ${isSubmenuOpen ? 'open' : ''} ${isSubmenuActive ? 'active' : ''}`}
              onClick={handleSubmenuToggle}
            >
              <IconComponent className="icon-svg" />
              <span>{item.label}</span>
              <span className="material-symbols-outlined submenu-arrow">expand_more</span>
            </button>
            {isSubmenuOpen && (
              <div className="nav-submenu">
                {submenuItems.map((subitem) => {
                  const isSubitemActive = location.pathname === subitem.to || 
                                         location.pathname.startsWith(subitem.to + '/');
                  
                  const handleSubitemClick = () => {
                    setIsProfileMenuOpen(false);
                    if (isMobile) setIsMobileMenuOpen(false);
                  };

                  return (
                    <NavLink
                      key={subitem.to}
                      to={subitem.to}
                      className={isSubitemActive ? 'active' : ''}
                      onClick={handleSubitemClick}
                    >
                      <span className="submenu-item-label">{subitem.label}</span>
                    </NavLink>
                  );
                })}
              </div>
            )}
          </div>
        );
      } else {
        // Render regular nav item
        // Check if user mode navigation item is blocked
        const isBlocked = mode === 'user' && item.to && !allowedUserNav.includes(item.to);

        const handleNavClick = () => {
          setIsProfileMenuOpen(false);
          if (isMobile) setIsMobileMenuOpen(false);
        };

        const isActive = item.to && isNavItemActive(item.to, item.end);

        const navLinkProps = {
          to: item.to || '',
          end: item.end,
          className: isActive ? 'active' : '',
          onClick: handleNavClick,
          ...(isBlocked && {
            onClick: (e: React.MouseEvent) => {
              e.preventDefault();
              setShowAccessModal(true);
              if (isMobile) setIsMobileMenuOpen(false);
            },
            style: { pointerEvents: 'none' as const, opacity: 0.5, cursor: 'not-allowed' }
          }),
        };

        return (
          <NavLink key={item.to} {...navLinkProps}>
            <IconComponent className="icon-svg" />
            <span>{item.label}</span>
          </NavLink>
        );
      }
    });
  };

  return (
    <div className={`panel ${isDarkMode ? 'dark' : ''} ${shouldHideSidebar ? 'panel--no-sidebar' : ''}`}>
      {/* Mobile Header with Burger Button - only visible on mobile */}
      {!shouldHideSidebar && (
        <div className="panel__mobile-header-wrapper">
          <header className="panel__mobile-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, padding: 0, background: isDarkMode ? '#1a2233' : '#fff' }}>
            <div style={{ position: 'relative', width: '100%', height: '60px', display: 'flex', alignItems: 'center' }}>
              <button
                className="panel__mobile-menu-btn"
                onClick={() => setIsMobileMenuOpen(true)}
                aria-label="Open navigation menu"
                style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', padding: '0.5rem', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 0 }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#11b694" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
              </button>
              <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img className="logo-full" src={LogoImgtxt} alt="Logo" style={{ height: '44px', width: 'auto' }} />
              </div>
            </div>
          </header>
        </div>
      )}

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="panel__mobile-overlay" onClick={(e: React.MouseEvent) => { if (e.currentTarget === e.target) { setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); } }}>
          <aside className="panel__mobile-sidebar" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
            {/* Only logo and close button, not the full header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 1.5rem 1rem 1.5rem', borderBottom: '1px solid #eee' }}>
              <div className="panel__logo">
                <img className="logo-full" src={LogoImgtxt} alt="Logo" />
              </div>
              <button
                className="panel__close-btn"
                onClick={() => { setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); }}
                aria-label="Close navigation menu"
              >
                <X className="panel__close-icon" />
              </button>
            </div>
            <nav className="panel__nav">
              {dashboardMode === 'user' && (
                <>
                  {renderNavItems('user', true)}
                  {isDeveloper && (
                    <NavLink
                      to="/panel/data-permissions"
                      className={isNavItemActive('/panel/data-permissions') ? 'active' : ''}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      <Settings className="icon-svg" />
                      <span>Data Control</span>
                    </NavLink>
                  )}
                </>
              )}
              {dashboardMode === 'consultant' && renderNavItems('consultant', true)}
              {dashboardMode === 'enterprise' && renderNavItems('enterprise', true)}
              {dashboardMode === 'admin' && renderNavItems('admin', true)}
              <NavLink
                to="/panel/profile"
                className={({isActive}) => isActive ? 'active' : ''}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <User className="icon-svg" />
                <span>Profile</span>
              </NavLink>
            </nav>
            <div className="panel__profile" ref={mobileProfileMenuRef}>
              <button
                ref={mobileProfileBtnRef}
                className="panel__profile-btn"
                aria-haspopup="menu"
                aria-expanded={isProfileMenuOpen}
                onClick={(e: React.MouseEvent) => { e.stopPropagation(); setIsProfileMenuOpen(v => !v); }}
              >
                <div className="panel__avatar">
                  {((user?.profile?.preferredName || user?.profile?.firstName || user?.email || 'U')[0]).toUpperCase()}
                </div>
                <span className="panel__profile-name">{user?.profile?.preferredName || user?.profile?.firstName || user?.email || 'Profile'}</span>
              </button>
              {isProfileMenuOpen && (
                <div className="panel__profile-menu" role="menu" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
                  <button role="menuitem" onClick={() => { navigate('/panel/profile'); setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); }} className="panel__profile-menu-item">Profile</button>
                  {allowedModes.includes('consultant') && (
                    <button role="menuitem" onClick={() => { setDashboardMode('consultant'); navigate('/panel/consultant'); setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'consultant' ? 'panel__profile-menu-item--active' : ''}`}>Consultant</button>
                  )}
                  {allowedModes.includes('enterprise') && (
                    <button role="menuitem" onClick={() => { setDashboardMode('enterprise'); navigate('/panel/enterprise'); setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'enterprise' ? 'panel__profile-menu-item--active' : ''}`}>Enterprise</button>
                  )}
                  {allowedModes.includes('admin') && (
                    <button role="menuitem" onClick={() => { setDashboardMode('admin'); navigate('/panel/admin'); setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'admin' ? 'panel__profile-menu-item--active' : ''}`}>Admin</button>
                  )}
                  {allowedModes.includes('user') && (
                    <button role="menuitem" onClick={() => { setDashboardMode('user'); navigate('/panel/dashboard'); setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'user' ? 'panel__profile-menu-item--active' : ''}`}>User</button>
                  )}
                  <div className="panel__profile-menu-sep" />
                  <div role="menuitem" onClick={() => setIsProfileMenuOpen(false)} className="panel__profile-menu-item"><ThemeToggle /></div>
                  <button role="menuitem" onClick={() => { logout(); navigate('/login'); setIsMobileMenuOpen(false); setIsProfileMenuOpen(false); }} className="panel__profile-menu-item panel__profile-menu-item--danger">Logout</button>
                </div>
              )}
            </div>
          </aside>
        </div>
      )}

      {/* Desktop Sidebar */}
      {!shouldHideSidebar && (
        <aside className="panel__sidebar" onMouseLeave={() => setIsProfileMenuOpen(false)}>
        <div className="panel__logo">
          <img className="logo-full" src={LogoImgtxt} alt="Logo" />
          <img className="logo-small" src={LogoSmall} alt="Logo small" />
        </div>
        <nav className="panel__nav">
          {dashboardMode === 'user' && (
            <>
              {renderNavItems('user')}
              {isDeveloper && (
                <NavLink to="/panel/data-permissions" className={isNavItemActive('/panel/data-permissions') ? 'active' : ''}><Settings className="icon-svg" /><span>Data Control</span></NavLink>
              )}
            </>
          )}
          {dashboardMode === 'consultant' && renderNavItems('consultant')}
          {dashboardMode === 'enterprise' && renderNavItems('enterprise')}
          {dashboardMode === 'admin' && renderNavItems('admin')}
        </nav>
        <div className="panel__profile" ref={profileMenuRef}>
          <button
            ref={profileBtnRef}
            className="panel__profile-btn"
            aria-haspopup="menu"
            aria-expanded={isProfileMenuOpen}
            onClick={() => setIsProfileMenuOpen(v => !v)}
          >
            <div className="panel__avatar">
              {((user?.profile?.preferredName || user?.profile?.firstName || user?.email || 'U')[0]).toUpperCase()}
            </div>
            <span className="panel__profile-name">{user?.profile?.preferredName || user?.profile?.firstName || user?.email || 'Profile'}</span>
          </button>
          {isProfileMenuOpen && (
            <div className="panel__profile-menu" role="menu">
              <button role="menuitem" onClick={() => { navigate('/panel/profile'); setIsProfileMenuOpen(false); }} className="panel__profile-menu-item">Profile</button>
              {allowedModes.includes('consultant') && (
                <button role="menuitem" onClick={() => { setDashboardMode('consultant'); navigate('/panel/consultant'); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'consultant' ? 'panel__profile-menu-item--active' : ''}`}>Consultant</button>
              )}
              {allowedModes.includes('enterprise') && (
                <button role="menuitem" onClick={() => { setDashboardMode('enterprise'); navigate('/panel/enterprise'); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'enterprise' ? 'panel__profile-menu-item--active' : ''}`}>Enterprise</button>
              )}
              {allowedModes.includes('admin') && (
                <button role="menuitem" onClick={() => { setDashboardMode('admin'); navigate('/panel/admin'); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'admin' ? 'panel__profile-menu-item--active' : ''}`}>Admin</button>
              )}
              {allowedModes.includes('user') && (
                <button role="menuitem" onClick={() => { setDashboardMode('user'); navigate('/panel/dashboard'); setIsProfileMenuOpen(false); }} className={`panel__profile-menu-item ${dashboardMode === 'user' ? 'panel__profile-menu-item--active' : ''}`}>User</button>
              )}
              <div className="panel__profile-menu-sep" />
              <div role="menuitem" onClick={() => setIsProfileMenuOpen(false)} className="panel__profile-menu-item"><ThemeToggle /></div>
              <button role="menuitem" onClick={() => { logout(); navigate('/login'); setIsProfileMenuOpen(false); }} className="panel__profile-menu-item panel__profile-menu-item--danger">Logout</button>
            </div>
          )}
        </div>
        </aside>
      )}
      <main className="panel__content">
        <Routes>
                    <Route path="financial-planning" element={<FinancialPlanningResourcePage/>} />
                    <Route path="financial-planning/module-1" element={<FinancialPlanningModule1Page/>} />
                    <Route path="financial-planning/module-2" element={<FinancialPlanningModule2Page/>} />
                    <Route path="financial-planning/module-3" element={<FinancialPlanningModule3Page/>} />
          <Route path="" element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage/>} />
          <Route path="consultant" element={<ConsultantDashboardPage/>} />
          <Route path="admin" element={<AdminDashboardPage/>} />
          <Route path="admin/subscriber-management" element={<SubscriberManagementPage/>} />
          <Route path="admin/subscriber-management/:id" element={<SubscriberDetailPage/>} />
          <Route path="admin/subscriber-management/:id/edit" element={<EditUserPage/>} />
          {/* Redirect routes for backward compatibility */}
          <Route path="subscriber-management" element={<Navigate to="admin/subscriber-management" replace />} />
          <Route path="subscriber-management/:id" element={<Navigate to="admin/subscriber-management/:id" replace />} />
          <Route path="subscriber-management/:id/edit" element={<Navigate to="admin/subscriber-management/:id/edit" replace />} />
          <Route path="subscription-plans" element={<Navigate to="admin/subscription-plans" replace />} />
          <Route path="subscription-plans/edit/:id?" element={<Navigate to="admin/subscription-plans/edit/:id" replace />} />
          <Route path="admin/subscription-plans" element={<SubscriptionPlansPage />} />
          <Route path="admin/subscription-plans/edit/:id?" element={<SubscriptionPlanEditPage />} />
          <Route path="admin/suggestions" element={<AdminSuggestionsPage />} />
          <Route path="admin/theme" element={<ConsultantThemePage/>} />
          <Route path="consultant/vulnerabilities" element={<ConsultantVulnerabilitiesPage/>} />
          <Route path="consultant/overview" element={<ConsultantOverviewPage/>} />
          <Route path="consultant/reports" element={<ConsultantReportsPage/>} />
          <Route path="consultant/users" element={<ConsultantUserTPage/>} />
          <Route path="consultant/group-creation/:folderId?" element={<ConsultantGroupWorkspacePage/>} />
          <Route path="consultant/group-creation/group/:id" element={<ConsultantGroupDetailsPage/>} />
          <Route path="consultant/enterprise-groups" element={<ConsultantEnterpriseGroupsPage/>} />
          <Route path="consultant/wellness" element={<ConsultantWellnessPage/>} />
          <Route path="consultant/wellness-module-creation" element={<ConsultantWellnessModuleCreationPage/>} />
          <Route path="consultant/wellness-module-creation/:id" element={<ConsultantWellnessModuleCreationPage/>} />
          <Route path="consultant/wellness-session-creation" element={<ConsultantWellnessSessionCreationPage/>} />
          <Route path="consultant/wellness-session-creation/:id" element={<ConsultantWellnessSessionCreationPage/>} />
          <Route path="consultant/wellness-creation" element={<ConsultantWellnessCreationPage/>} />
          <Route path="consultant/user/:id" element={<ConsultantUsersPage/>} />
          <Route path="consultant/profile" element={<ConsultantProfilePage/>} />
          <Route path="consultant/usert" element={<Navigate to="consultant/users" replace />} />
          <Route path="consultant/sowb-breakdown" element={<ConsultantSowbBreakdownPage/>} />
          <Route path="enterprise" element={<EnterpriseDashboardPage/>} />
          <Route path="enterprise/vulnerabilities" element={<EnterpriseVulnerabilitiesPage/>} />
          <Route path="enterprise/overview" element={<EnterpriseOverviewPage/>} />
          <Route path="enterprise/reports" element={<EnterpriseReportsPage/>} />
          <Route path="enterprise/sowb-breakdown" element={<EnterpriseSowbBreakdownPage/>} />
          <Route path="enterprise/users" element={<ConsultantUserTPage/>} />
          <Route path="enterprise/user/:id" element={<ConsultantUsersPage/>} />
          <Route path="enterprise/groups" element={<EnterpriseGroupsPage/>} />
          <Route path="enterprise/groups/:id" element={<EnterpriseGroupsPage/>} />
          <Route path="enterprise/groups/view/:id" element={<ConsultantGroupDetailsPage/>} />
          <Route path="enterprise/groups/edit/:id" element={<EnterpriseGroupEditPage/>} />
          <Route path="enterprise/branch/:id" element={<BranchDetailPage/>} />
          <Route path="enterprise/group-creation" element={<EnterpriseGroupCreationPage/>} />
          <Route path="enterprise/management" element={<EnterpriseConsolidationPage/>} />
          <Route path="enterprise/profile/:id" element={<EnterpriseProfilePage/>} />
          <Route path="dashboard/morning-meditation" element={<MorningMeditationPage/>} />
          <Route path="dashboard/morning-meditation/session-1" element={<MorningMeditationSession1/>} />
          <Route path="dashboard/morning-meditation/session-2" element={<MorningMeditationSession2/>} />
          <Route path="dashboard/morning-meditation/session-3" element={<MorningMeditationSession3/>} />
          <Route path="dashboard/wellness-session/:id" element={<WellnessSessionDetailPage/>} />
          <Route path="dashboard/yoga-flow" element={<YogaFlowPage/>} />
          <Route path="dashboard/yoga-flow/session-1" element={<YogaFlowSession1/>} />
          <Route path="dashboard/yoga-flow/session-2" element={<YogaFlowSession2/>} />
          <Route path="dashboard/yoga-flow/session-3" element={<YogaFlowSession3/>} />
          <Route path="dashboard/yoga-flow/session-4" element={<YogaFlowSession4/>} />
          <Route path="dashboard/yoga-flow/session-5" element={<YogaFlowSession5/>} />
          <Route path="dashboard/outdoor-run" element={<OutdoorRunPage/>} />
          <Route path="dashboard/outdoor-run/session-1" element={<OutdoorRunSession1/>} />
          <Route path="dashboard/outdoor-run/session-2" element={<OutdoorRunSession2/>} />
          <Route path="dashboard/outdoor-run/session-3" element={<OutdoorRunSession3/>} />
          <Route path="dashboard/sleeping-meditation" element={<SleepingMeditationPage/>} />
          <Route path="dashboard/sleeping-meditation/session-1" element={<SleepingMeditationSession1/>} />
          <Route path="dashboard/sleeping-meditation/session-2" element={<SleepingMeditationSession2/>} />
          <Route path="dashboard/sleeping-meditation/session-3" element={<SleepingMeditationSession3/>} />
          <Route path="dashboard/sleeping-meditation/bedtime-story-1" element={<BedtimeStory1/>} />
           <Route path="dashboard/sleeping-meditation/bedtime-story-2" element={<BedtimeStory2/>} />
           <Route path="dashboard/sleeping-meditation/bedtime-story-3" element={<BedtimeStory3/>} />
          <Route path="chat" element={<ChatPage/>} />
          <Route path="wellness" element={<WellnessPage/>} />
          <Route path="wellness/details" element={<StarOfWellBeingDetailsPage/>} />
          <Route path="wellness/dass" element={<AudioProvider><DassPage/></AudioProvider>} />
          <Route path="wellness/dass/assessment" element={<AudioProvider><DassAssessmentPage/></AudioProvider>} />
          <Route path="star-of-wellbeing/assessment/completion" element={<AudioProvider><StarOfWellbeingCompletion/></AudioProvider>} />
          <Route path="wellness-loop" element={<WellnessLoopPage/>} />
          <Route path="wellness-loop/healthy-eating-habits" element={<HealthyEatingHabitsPage/>} />
          <Route path="wellness-loop/healthy-eating-module-1" element={<HealthyEatingModule1Page/>} />
          <Route path="wellness-loop/healthy-eating-module-2" element={<HealthyEatingModule2Page/>} />
          <Route path="wellness-loop/healthy-eating-module-3" element={<HealthyEatingModule3Page/>} />
          <Route path="wellness-loop/healthy-eating-module-4" element={<HealthyEatingModule4Page/>} />
          <Route path="wellness/blood-test-input" element={<BloodTestInputPage/>} />
          <Route path="learn" element={<LearnPage/>} />
          <Route path="learn/spiritual-resources" element={<SpiritualResourcesPage/>} />
          <Route path="insights" element={<InsightsPage/>} />
                <Route path="learn/spiritual-assessment" element={<SpiritualAssessmentFormPage/>} />
                <Route path="learn/nutritional-assessment" element={<NutritionalAssessmentFormPage/>} />
                <Route path="learn/emotio-psycho-rational-assessment" element={<EmotioPsychoRationalAssessmentFormPage/>} />
                <Route path="learn/legendarial-assessment" element={<LegendarialAssessmentFormPage/>} />
                <Route path="learn/religio-traditio-cultural-assessment" element={<ReligioTraditioCulturalAssessmentFormPage/>} />
                <Route path="learn/socio-relational-assessment" element={<SocioRelationalAssessmentFormPage/>} />
                <Route path="learn/financial-assessment" element={<FinancialAssessmentFormPage/>} />
                <Route path="learn/environmental-assessment" element={<EnvironmentalAssessmentFormPage/>} />
                <Route path="learn/occupational-assessment" element={<OccupationalAssessmentFormPage/>} />
                <Route path="learn/spiritual-assessment/completion" element={<SpiritualAssessmentCompletionPage/>} />
                <Route path="learn/nutritional-assessment/completion" element={<NutritionalAssessmentCompletionPage/>} />
                <Route path="learn/emotio-psycho-rational-assessment/completion" element={<EmotioPsychoRationalAssessmentCompletionPage/>} />
                <Route path="learn/legendarial-assessment/completion" element={<LegendarialAssessmentCompletionPage/>} />
                <Route path="learn/religio-traditio-cultural-assessment/completion" element={<ReligioTraditioCulturalAssessmentCompletionPage/>} />
                <Route path="learn/socio-relational-assessment/completion" element={<SocioRelationalAssessmentCompletionPage/>} />
                <Route path="learn/financial-assessment/completion" element={<FinancialAssessmentCompletionPage/>} />
                <Route path="learn/environmental-assessment/completion" element={<EnvironmentalAssessmentCompletionPage/>} />
                <Route path="learn/occupational-assessment/completion" element={<OccupationalAssessmentCompletionPage/>} />
          <Route path="learn/physical-wellness-assessment" element={<PhysicalWellnessLearnAssessmentPage/>} />
          <Route path="learn/physical-wellness-assessment/completion" element={<PhysicalWellnessLearnAssessmentCompletionPage/>} />
          <Route path="learn/general-physical-assessment/completion" element={<GeneralPhysicalAssessmentCompletionPage/>} />
          <Route path="learn/ipaq-sf-assessment/completion" element={<IPAQSFAssessmentCompletionPage/>} />
          <Route path="learn/psqi-assessment/completion" element={<PSQIAssessmentCompletionPage/>} />
          <Route path="learn/assessments" element={<AssessmentsPage/>} />
          <Route path="learn/ground-work" element={<GroundWorkPage/>} />
          <Route path="consultations" element={<ConsultationsPage/>} />
          <Route path="group-list" element={<GroupListPage/>} />
          <Route path="data-permissions" element={<DataPermissionsPage/>} />
          <Route path="profile" element={<ProfilePage isDeveloper={isDeveloper} setIsDeveloper={setIsDeveloper}/>} />
          <Route path="profile/details" element={<UserDetailedProfilePage/>} />
          <Route path="subscription" element={<SubscriptionPage/>} />
          <Route path="billing-history" element={<BillingHistoryPage/>} />
          <Route path="payment/setup" element={<PaymentSetupPage/>} />
          <Route path="learn/spiritual-module-1" element={<SpiritualModule1Page/>} />
          <Route path="learn/spiritual-module-2" element={<SpiritualModule2Page/>} />
          <Route path="learn/spiritual-module-3" element={<SpiritualModule3Page/>} />
          <Route path="learn/spiritual-module-4" element={<SpiritualModule4Page/>} />
          <Route path="learn/spiritual-module-5" element={<SpiritualModule5Page/>} />
          <Route path="learn/spiritual-module-6" element={<SpiritualModule6Page/>} />
          <Route path="learn/spiritual-module-7" element={<SpiritualModule7Page/>} />
          <Route path="learn/spiritual-module-1/quiz" element={<SpiritualModule1QuizPage/>} />
          <Route path="learn/spiritual-module-2/quiz" element={<SpiritualModule2QuizPage/>} />
          <Route path="learn/spiritual-module-3/quiz" element={<SpiritualModule3QuizPage/>} />
          <Route path="learn/spiritual-module-4/quiz" element={<SpiritualModule4QuizPage/>} />
          <Route path="learn/spiritual-module-5/quiz" element={<SpiritualModule5QuizPage/>} />
          <Route path="learn/spiritual-module-6/quiz" element={<SpiritualModule6QuizPage/>} />
          <Route path="learn/spiritual-module-7/quiz" element={<SpiritualModule7QuizPage/>} />
          <Route path="learn/nutritional-resources" element={<NutritionalResourcesPage/>} />
          <Route path="learn/emotio-psycho-rational-resources" element={<EmotioPsychoRationalResourcesPage/>} />
          <Route path="learn/nutritional-module-1" element={<NutritionalModule1Page />} />
          <Route path="learn/nutritional-module-1/quiz" element={<NutritionalModule1QuizPage />} />
          <Route path="learn/nutritional-module-2" element={<NutritionalModule2Page />} />
          <Route path="learn/nutritional-module-2/quiz" element={<NutritionalModule2QuizPage />} />
          <Route path="learn/nutritional-module-3" element={<NutritionalModule3Page />} />
          <Route path="learn/nutritional-module-3/quiz" element={<NutritionalModule3QuizPage />} />
          <Route path="learn/nutritional-module-4" element={<NutritionalModule4Page />} />
          <Route path="learn/nutritional-module-4/quiz" element={<NutritionalModule4QuizPage />} />
          <Route path="learn/nutritional-module-5" element={<NutritionalModule5Page />} />
          <Route path="learn/nutritional-module-5/quiz" element={<NutritionalModule5QuizPage />} />
          <Route path="learn/nutritional-module-6" element={<NutritionalModule6Page />} />
          <Route path="learn/nutritional-module-6/quiz" element={<NutritionalModule6QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-1" element={<EmotioPsychoRationalModule1Page />} />
          <Route path="learn/emotio-psycho-rational-module-1/quiz" element={<EmotioPsychoRationalModule1QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-2" element={<EmotioPsychoRationalModule2Page />} />
          <Route path="learn/emotio-psycho-rational-module-2/quiz" element={<EmotioPsychoRationalModule2QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-3" element={<EmotioPsychoRationalModule3Page />} />
          <Route path="learn/emotio-psycho-rational-module-3/quiz" element={<EmotioPsychoRationalModule3QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-4" element={<EmotioPsychoRationalModule4Page />} />
          <Route path="learn/emotio-psycho-rational-module-4/quiz" element={<EmotioPsychoRationalModule4QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-5" element={<EmotioPsychoRationalModule5Page />} />
          <Route path="learn/emotio-psycho-rational-module-5/quiz" element={<EmotioPsychoRationalModule5QuizPage />} />
          <Route path="learn/physical-resources" element={<PhysicalResourcesPage />} />
          <Route path="learn/physical-module-1" element={<PhysicalModule1Page />} />
          <Route path="learn/physical-module-1/quiz" element={<PhysicalModule1QuizPage />} />
          <Route path="learn/physical-module-2" element={<PhysicalModule2Page />} />
          <Route path="learn/physical-module-2/quiz" element={<PhysicalModule2QuizPage />} />
          <Route path="learn/physical-module-3" element={<PhysicalModule3Page />} />
          <Route path="learn/physical-module-3/quiz" element={<PhysicalModule3QuizPage />} />
          <Route path="learn/occupational-resources" element={<OccupationalResourcesPage />} />
          <Route path="learn/occupational-module-1" element={<OccupationalModule1Page />} />
          <Route path="learn/occupational-module-2" element={<OccupationalModule2Page />} />
          <Route path="learn/occupational-module-3" element={<OccupationalModule3Page />} />
          <Route path="learn/occupational-module-4" element={<OccupationalModule4Page />} />
          <Route path="learn/occupational-module-5" element={<OccupationalModule5Page />} />
          <Route path="learn/occupational-module-1/quiz" element={<OccupationalModule1QuizPage />} />
          <Route path="learn/occupational-module-2/quiz" element={<OccupationalModule2QuizPage />} />
          <Route path="learn/occupational-module-3/quiz" element={<OccupationalModule3QuizPage />} />
          <Route path="learn/occupational-module-4/quiz" element={<OccupationalModule4QuizPage />} />
          <Route path="learn/occupational-module-5/quiz" element={<OccupationalModule5QuizPage />} />
          <Route path="learn/legendarial-resources" element={<LegendarialResourcesPage />} />
          <Route path="learn/legendarial-module-1" element={<LegendarialModule1Page />} />
          <Route path="learn/legendarial-module-2" element={<LegendarialModule2Page />} />
          <Route path="learn/legendarial-module-3" element={<LegendarialModule3Page />} />
          <Route path="learn/legendarial-module-4" element={<LegendarialModule4Page />} />
          <Route path="learn/legendarial-module-5" element={<LegendarialModule5Page />} />
          <Route path="learn/legendarial-module-1/quiz" element={<LegendarialModule1QuizPage />} />
          <Route path="learn/legendarial-module-2/quiz" element={<LegendarialModule2QuizPage />} />
          <Route path="learn/legendarial-module-3/quiz" element={<LegendarialModule3QuizPage />} />
          <Route path="learn/legendarial-module-4/quiz" element={<LegendarialModule4QuizPage />} />
          <Route path="learn/legendarial-module-5/quiz" element={<LegendarialModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-resources" element={<ReligioTraditioCulturalResourcesPage />} />
          <Route path="learn/religio-traditio-cultural-module-1" element={<ReligioTraditioCulturalModule1Page />} />
          <Route path="learn/religio-traditio-cultural-module-2" element={<ReligioTraditioCulturalModule2Page />} />
          <Route path="learn/religio-traditio-cultural-module-3" element={<ReligioTraditioCulturalModule3Page />} />
          <Route path="learn/religio-traditio-cultural-module-4" element={<ReligioTraditioCulturalModule4Page />} />
          <Route path="learn/religio-traditio-cultural-module-5" element={<ReligioTraditioCulturalModule5Page />} />
          <Route path="learn/religio-traditio-cultural-module-6" element={<ReligioTraditioCulturalModule6Page />} />
          <Route path="learn/religio-traditio-cultural-module-1/quiz" element={<ReligioTraditioCulturalModule1QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-2/quiz" element={<ReligioTraditioCulturalModule2QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-3/quiz" element={<ReligioTraditioCulturalModule3QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-4/quiz" element={<ReligioTraditioCulturalModule4QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-5/quiz" element={<ReligioTraditioCulturalModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-6/quiz" element={<ReligioTraditioCulturalModule6QuizPage />} />
          <Route path="learn/socio-relational-resources" element={<SocioRelationalResourcesPage />} />
          <Route path="learn/socio-relational-module-1" element={<SocioRelationalModule1Page />} />
          <Route path="learn/socio-relational-module-2" element={<SocioRelationalModule2Page />} />
          <Route path="learn/socio-relational-module-3" element={<SocioRelationalModule3Page />} />
          <Route path="learn/socio-relational-module-4" element={<SocioRelationalModule4Page />} />
          <Route path="learn/socio-relational-module-5" element={<SocioRelationalModule5Page />} />
          <Route path="learn/socio-relational-module-1/quiz" element={<SocioRelationalModule1QuizPage />} />
          <Route path="learn/socio-relational-module-2/quiz" element={<SocioRelationalModule2QuizPage />} />
          <Route path="learn/socio-relational-module-3/quiz" element={<SocioRelationalModule3QuizPage />} />
          <Route path="learn/socio-relational-module-4/quiz" element={<SocioRelationalModule4QuizPage />} />
          <Route path="learn/socio-relational-module-5/quiz" element={<SocioRelationalModule5QuizPage />} />
          <Route path="learn/financial-resources" element={<FinancialResourcesPage />} />
          <Route path="learn/financial-module-1" element={<FinancialModule1Page />} />
          <Route path="learn/financial-module-2" element={<FinancialModule2Page />} />
          <Route path="learn/financial-module-3" element={<FinancialModule3Page />} />
          <Route path="learn/financial-module-4" element={<FinancialModule4Page />} />
          <Route path="learn/financial-module-5" element={<FinancialModule5Page />} />
          <Route path="learn/financial-module-1/quiz" element={<FinancialModule1QuizPage />} />
          <Route path="learn/financial-module-2/quiz" element={<FinancialModule2QuizPage />} />
          <Route path="learn/financial-module-3/quiz" element={<FinancialModule3QuizPage />} />
          <Route path="learn/financial-module-4/quiz" element={<FinancialModule4QuizPage />} />
          <Route path="learn/financial-module-5/quiz" element={<FinancialModule5QuizPage />} />
          <Route path="learn/environmental-resources" element={<EnvironmentalResourcesPage />} />
          <Route path="learn/environmental-module-1" element={<EnvironmentalModule1Page />} />
          <Route path="learn/environmental-module-2" element={<EnvironmentalModule2Page />} />
          <Route path="learn/environmental-module-3" element={<EnvironmentalModule3Page />} />
          <Route path="learn/environmental-module-4" element={<EnvironmentalModule4Page />} />
          <Route path="learn/environmental-module-5" element={<EnvironmentalModule5Page />} />
          <Route path="learn/environmental-module-6" element={<EnvironmentalModule6Page />} />
          <Route path="learn/environmental-module-1/quiz" element={<EnvironmentalModule1QuizPage />} />
          <Route path="learn/environmental-module-2/quiz" element={<EnvironmentalModule2QuizPage />} />
          <Route path="learn/environmental-module-3/quiz" element={<EnvironmentalModule3QuizPage />} />
          <Route path="learn/environmental-module-4/quiz" element={<EnvironmentalModule4QuizPage />} />
          <Route path="learn/environmental-module-5/quiz" element={<EnvironmentalModule5QuizPage />} />
          <Route path="learn/environmental-module-6/quiz" element={<EnvironmentalModule6QuizPage />} />
          <Route path="learn/healthy-eating-habits" element={<HealthyEatingHabitsPage/>} />
          <Route path="learn/healthy-eating-module-1" element={<HealthyEatingModule1Page/>} />
          <Route path="learn/healthy-eating-module-2" element={<HealthyEatingModule2Page/>} />
          <Route path="learn/healthy-eating-module-3" element={<HealthyEatingModule3Page/>} />
          <Route path="learn/healthy-eating-module-4" element={<HealthyEatingModule4Page/>} />
          <Route path="learn/financial-planning" element={<FinancialPlanningResourcePage/>} />
          <Route path="learn/financial-planning/module-1" element={<FinancialPlanningModule1Page/>} />
          <Route path="learn/financial-planning/module-2" element={<FinancialPlanningModule2Page/>} />
          <Route path="learn/financial-planning/module-3" element={<FinancialPlanningModule3Page/>} />
          <Route path="learn/physical-wellness-assessment" element={<PhysicalWellnessLearnAssessmentPage/>} />
          <Route path="learn/physical-wellness-assessment/completion" element={<PhysicalWellnessLearnAssessmentCompletionPage/>} />
          <Route path="learn/general-physical-assessment/completion" element={<GeneralPhysicalAssessmentCompletionPage/>} />
          <Route path="learn/ipaq-sf-assessment/completion" element={<IPAQSFAssessmentCompletionPage/>} />
          <Route path="learn/psqi-assessment/completion" element={<PSQIAssessmentCompletionPage/>} />
          <Route path="learn/assessments" element={<AssessmentsPage/>} />
          <Route path="learn/ground-work" element={<GroundWorkPage/>} />
          <Route path="consultations" element={<ConsultationsPage/>} />
          <Route path="group-list" element={<GroupListPage/>} />
          <Route path="data-permissions" element={<DataPermissionsPage/>} />
          <Route path="profile" element={<ProfilePage isDeveloper={isDeveloper} setIsDeveloper={setIsDeveloper}/>} />
          <Route path="profile/details" element={<UserDetailedProfilePage/>} />
          <Route path="subscription" element={<SubscriptionPage/>} />
          <Route path="billing-history" element={<BillingHistoryPage/>} />
          <Route path="payment/setup" element={<PaymentSetupPage/>} />
          <Route path="learn/spiritual-module-1" element={<SpiritualModule1Page/>} />
          <Route path="learn/spiritual-module-2" element={<SpiritualModule2Page/>} />
          <Route path="learn/spiritual-module-3" element={<SpiritualModule3Page/>} />
          <Route path="learn/spiritual-module-4" element={<SpiritualModule4Page/>} />
          <Route path="learn/spiritual-module-5" element={<SpiritualModule5Page/>} />
          <Route path="learn/spiritual-module-6" element={<SpiritualModule6Page/>} />
          <Route path="learn/spiritual-module-7" element={<SpiritualModule7Page/>} />
          <Route path="learn/spiritual-module-1/quiz" element={<SpiritualModule1QuizPage/>} />
          <Route path="learn/spiritual-module-2/quiz" element={<SpiritualModule2QuizPage/>} />
          <Route path="learn/spiritual-module-3/quiz" element={<SpiritualModule3QuizPage/>} />
          <Route path="learn/spiritual-module-4/quiz" element={<SpiritualModule4QuizPage/>} />
          <Route path="learn/spiritual-module-5/quiz" element={<SpiritualModule5QuizPage/>} />
          <Route path="learn/spiritual-module-6/quiz" element={<SpiritualModule6QuizPage/>} />
          <Route path="learn/spiritual-module-7/quiz" element={<SpiritualModule7QuizPage/>} />
          <Route path="learn/nutritional-resources" element={<NutritionalResourcesPage/>} />
          <Route path="learn/emotio-psycho-rational-resources" element={<EmotioPsychoRationalResourcesPage/>} />
          <Route path="learn/nutritional-module-1" element={<NutritionalModule1Page />} />
          <Route path="learn/nutritional-module-1/quiz" element={<NutritionalModule1QuizPage />} />
          <Route path="learn/nutritional-module-2" element={<NutritionalModule2Page />} />
          <Route path="learn/nutritional-module-2/quiz" element={<NutritionalModule2QuizPage />} />
          <Route path="learn/nutritional-module-3" element={<NutritionalModule3Page />} />
          <Route path="learn/nutritional-module-3/quiz" element={<NutritionalModule3QuizPage />} />
          <Route path="learn/nutritional-module-4" element={<NutritionalModule4Page />} />
          <Route path="learn/nutritional-module-4/quiz" element={<NutritionalModule4QuizPage />} />
          <Route path="learn/nutritional-module-5" element={<NutritionalModule5Page />} />
          <Route path="learn/nutritional-module-5/quiz" element={<NutritionalModule5QuizPage />} />
          <Route path="learn/nutritional-module-6" element={<NutritionalModule6Page />} />
          <Route path="learn/nutritional-module-6/quiz" element={<NutritionalModule6QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-1" element={<EmotioPsychoRationalModule1Page />} />
          <Route path="learn/emotio-psycho-rational-module-1/quiz" element={<EmotioPsychoRationalModule1QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-2" element={<EmotioPsychoRationalModule2Page />} />
          <Route path="learn/emotio-psycho-rational-module-2/quiz" element={<EmotioPsychoRationalModule2QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-3" element={<EmotioPsychoRationalModule3Page />} />
          <Route path="learn/emotio-psycho-rational-module-3/quiz" element={<EmotioPsychoRationalModule3QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-4" element={<EmotioPsychoRationalModule4Page />} />
          <Route path="learn/emotio-psycho-rational-module-4/quiz" element={<EmotioPsychoRationalModule4QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-5" element={<EmotioPsychoRationalModule5Page />} />
          <Route path="learn/emotio-psycho-rational-module-5/quiz" element={<EmotioPsychoRationalModule5QuizPage />} />
          <Route path="learn/physical-resources" element={<PhysicalResourcesPage />} />
          <Route path="learn/physical-module-1" element={<PhysicalModule1Page />} />
          <Route path="learn/physical-module-1/quiz" element={<PhysicalModule1QuizPage />} />
          <Route path="learn/physical-module-2" element={<PhysicalModule2Page />} />
          <Route path="learn/physical-module-2/quiz" element={<PhysicalModule2QuizPage />} />
          <Route path="learn/physical-module-3" element={<PhysicalModule3Page />} />
          <Route path="learn/physical-module-3/quiz" element={<PhysicalModule3QuizPage />} />
          <Route path="learn/occupational-resources" element={<OccupationalResourcesPage />} />
          <Route path="learn/occupational-module-1" element={<OccupationalModule1Page />} />
          <Route path="learn/occupational-module-2" element={<OccupationalModule2Page />} />
          <Route path="learn/occupational-module-3" element={<OccupationalModule3Page />} />
          <Route path="learn/occupational-module-4" element={<OccupationalModule4Page />} />
          <Route path="learn/occupational-module-5" element={<OccupationalModule5Page />} />
          <Route path="learn/occupational-module-1/quiz" element={<OccupationalModule1QuizPage />} />
          <Route path="learn/occupational-module-2/quiz" element={<OccupationalModule2QuizPage />} />
          <Route path="learn/occupational-module-3/quiz" element={<OccupationalModule3QuizPage />} />
          <Route path="learn/occupational-module-4/quiz" element={<OccupationalModule4QuizPage />} />
          <Route path="learn/occupational-module-5/quiz" element={<OccupationalModule5QuizPage />} />
          <Route path="learn/legendarial-resources" element={<LegendarialResourcesPage />} />
          <Route path="learn/legendarial-module-1" element={<LegendarialModule1Page />} />
          <Route path="learn/legendarial-module-2" element={<LegendarialModule2Page />} />
          <Route path="learn/legendarial-module-3" element={<LegendarialModule3Page />} />
          <Route path="learn/legendarial-module-4" element={<LegendarialModule4Page />} />
          <Route path="learn/legendarial-module-5" element={<LegendarialModule5Page />} />
          <Route path="learn/legendarial-module-1/quiz" element={<LegendarialModule1QuizPage />} />
          <Route path="learn/legendarial-module-2/quiz" element={<LegendarialModule2QuizPage />} />
          <Route path="learn/legendarial-module-3/quiz" element={<LegendarialModule3QuizPage />} />
          <Route path="learn/legendarial-module-4/quiz" element={<LegendarialModule4QuizPage />} />
          <Route path="learn/legendarial-module-5/quiz" element={<LegendarialModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-resources" element={<ReligioTraditioCulturalResourcesPage />} />
          <Route path="learn/religio-traditio-cultural-module-1" element={<ReligioTraditioCulturalModule1Page />} />
          <Route path="learn/religio-traditio-cultural-module-2" element={<ReligioTraditioCulturalModule2Page />} />
          <Route path="learn/religio-traditio-cultural-module-3" element={<ReligioTraditioCulturalModule3Page />} />
          <Route path="learn/religio-traditio-cultural-module-4" element={<ReligioTraditioCulturalModule4Page />} />
          <Route path="learn/religio-traditio-cultural-module-5" element={<ReligioTraditioCulturalModule5Page />} />
          <Route path="learn/religio-traditio-cultural-module-6" element={<ReligioTraditioCulturalModule6Page />} />
          <Route path="learn/religio-traditio-cultural-module-1/quiz" element={<ReligioTraditioCulturalModule1QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-2/quiz" element={<ReligioTraditioCulturalModule2QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-3/quiz" element={<ReligioTraditioCulturalModule3QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-4/quiz" element={<ReligioTraditioCulturalModule4QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-5/quiz" element={<ReligioTraditioCulturalModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-6/quiz" element={<ReligioTraditioCulturalModule6QuizPage />} />
          <Route path="learn/socio-relational-resources" element={<SocioRelationalResourcesPage />} />
          <Route path="learn/socio-relational-module-1" element={<SocioRelationalModule1Page />} />
          <Route path="learn/socio-relational-module-2" element={<SocioRelationalModule2Page />} />
          <Route path="learn/socio-relational-module-3" element={<SocioRelationalModule3Page />} />
          <Route path="learn/socio-relational-module-4" element={<SocioRelationalModule4Page />} />
          <Route path="learn/socio-relational-module-5" element={<SocioRelationalModule5Page />} />
          <Route path="learn/socio-relational-module-1/quiz" element={<SocioRelationalModule1QuizPage />} />
          <Route path="learn/socio-relational-module-2/quiz" element={<SocioRelationalModule2QuizPage />} />
          <Route path="learn/socio-relational-module-3/quiz" element={<SocioRelationalModule3QuizPage />} />
          <Route path="learn/socio-relational-module-4/quiz" element={<SocioRelationalModule4QuizPage />} />
          <Route path="learn/socio-relational-module-5/quiz" element={<SocioRelationalModule5QuizPage />} />
          <Route path="learn/financial-resources" element={<FinancialResourcesPage />} />
          <Route path="learn/financial-module-1" element={<FinancialModule1Page />} />
          <Route path="learn/financial-module-2" element={<FinancialModule2Page />} />
          <Route path="learn/financial-module-3" element={<FinancialModule3Page />} />
          <Route path="learn/financial-module-4" element={<FinancialModule4Page />} />
          <Route path="learn/financial-module-5" element={<FinancialModule5Page />} />
          <Route path="learn/financial-module-1/quiz" element={<FinancialModule1QuizPage />} />
          <Route path="learn/financial-module-2/quiz" element={<FinancialModule2QuizPage />} />
          <Route path="learn/financial-module-3/quiz" element={<FinancialModule3QuizPage />} />
          <Route path="learn/financial-module-4/quiz" element={<FinancialModule4QuizPage />} />
          <Route path="learn/financial-module-5/quiz" element={<FinancialModule5QuizPage />} />
          <Route path="learn/environmental-resources" element={<EnvironmentalResourcesPage />} />
          <Route path="learn/environmental-module-1" element={<EnvironmentalModule1Page />} />
          <Route path="learn/environmental-module-2" element={<EnvironmentalModule2Page />} />
          <Route path="learn/environmental-module-3" element={<EnvironmentalModule3Page />} />
          <Route path="learn/environmental-module-4" element={<EnvironmentalModule4Page />} />
          <Route path="learn/environmental-module-5" element={<EnvironmentalModule5Page />} />
          <Route path="learn/environmental-module-6" element={<EnvironmentalModule6Page />} />
          <Route path="learn/environmental-module-1/quiz" element={<EnvironmentalModule1QuizPage />} />
          <Route path="learn/environmental-module-2/quiz" element={<EnvironmentalModule2QuizPage />} />
          <Route path="learn/environmental-module-3/quiz" element={<EnvironmentalModule3QuizPage />} />
          <Route path="learn/environmental-module-4/quiz" element={<EnvironmentalModule4QuizPage />} />
          <Route path="learn/environmental-module-5/quiz" element={<EnvironmentalModule5QuizPage />} />
          <Route path="learn/environmental-module-6/quiz" element={<EnvironmentalModule6QuizPage />} />
          <Route path="learn/healthy-eating-habits" element={<HealthyEatingHabitsPage/>} />
          <Route path="learn/healthy-eating-module-1" element={<HealthyEatingModule1Page/>} />
          <Route path="learn/healthy-eating-module-2" element={<HealthyEatingModule2Page/>} />
          <Route path="learn/healthy-eating-module-3" element={<HealthyEatingModule3Page/>} />
          <Route path="learn/healthy-eating-module-4" element={<HealthyEatingModule4Page/>} />
          <Route path="learn/financial-planning" element={<FinancialPlanningResourcePage/>} />
          <Route path="learn/financial-planning/module-1" element={<FinancialPlanningModule1Page/>} />
          <Route path="learn/financial-planning/module-2" element={<FinancialPlanningModule2Page/>} />
          <Route path="learn/financial-planning/module-3" element={<FinancialPlanningModule3Page/>} />
          <Route path="learn/physical-wellness-assessment" element={<PhysicalWellnessLearnAssessmentPage/>} />
          <Route path="learn/physical-wellness-assessment/completion" element={<PhysicalWellnessLearnAssessmentCompletionPage/>} />
          <Route path="learn/general-physical-assessment/completion" element={<GeneralPhysicalAssessmentCompletionPage/>} />
          <Route path="learn/ipaq-sf-assessment/completion" element={<IPAQSFAssessmentCompletionPage/>} />
          <Route path="learn/psqi-assessment/completion" element={<PSQIAssessmentCompletionPage/>} />
          <Route path="learn/assessments" element={<AssessmentsPage/>} />
          <Route path="learn/ground-work" element={<GroundWorkPage/>} />
          <Route path="consultations" element={<ConsultationsPage/>} />
          <Route path="group-list" element={<GroupListPage/>} />
          <Route path="data-permissions" element={<DataPermissionsPage/>} />
          <Route path="profile" element={<ProfilePage isDeveloper={isDeveloper} setIsDeveloper={setIsDeveloper}/>} />
          <Route path="profile/details" element={<UserDetailedProfilePage/>} />
          <Route path="subscription" element={<SubscriptionPage/>} />
          <Route path="billing-history" element={<BillingHistoryPage/>} />
          <Route path="payment/setup" element={<PaymentSetupPage/>} />
          <Route path="learn/spiritual-module-1" element={<SpiritualModule1Page/>} />
          <Route path="learn/spiritual-module-2" element={<SpiritualModule2Page/>} />
          <Route path="learn/spiritual-module-3" element={<SpiritualModule3Page/>} />
          <Route path="learn/spiritual-module-4" element={<SpiritualModule4Page/>} />
          <Route path="learn/spiritual-module-5" element={<SpiritualModule5Page/>} />
          <Route path="learn/spiritual-module-6" element={<SpiritualModule6Page/>} />
          <Route path="learn/spiritual-module-7" element={<SpiritualModule7Page/>} />
          <Route path="learn/spiritual-module-1/quiz" element={<SpiritualModule1QuizPage/>} />
          <Route path="learn/spiritual-module-2/quiz" element={<SpiritualModule2QuizPage/>} />
          <Route path="learn/spiritual-module-3/quiz" element={<SpiritualModule3QuizPage/>} />
          <Route path="learn/spiritual-module-4/quiz" element={<SpiritualModule4QuizPage/>} />
          <Route path="learn/spiritual-module-5/quiz" element={<SpiritualModule5QuizPage/>} />
          <Route path="learn/spiritual-module-6/quiz" element={<SpiritualModule6QuizPage/>} />
          <Route path="learn/spiritual-module-7/quiz" element={<SpiritualModule7QuizPage/>} />
          <Route path="learn/nutritional-resources" element={<NutritionalResourcesPage/>} />
          <Route path="learn/emotio-psycho-rational-resources" element={<EmotioPsychoRationalResourcesPage/>} />
          <Route path="learn/nutritional-module-1" element={<NutritionalModule1Page />} />
          <Route path="learn/nutritional-module-1/quiz" element={<NutritionalModule1QuizPage />} />
          <Route path="learn/nutritional-module-2" element={<NutritionalModule2Page />} />
          <Route path="learn/nutritional-module-2/quiz" element={<NutritionalModule2QuizPage />} />
          <Route path="learn/nutritional-module-3" element={<NutritionalModule3Page />} />
          <Route path="learn/nutritional-module-3/quiz" element={<NutritionalModule3QuizPage />} />
          <Route path="learn/nutritional-module-4" element={<NutritionalModule4Page />} />
          <Route path="learn/nutritional-module-4/quiz" element={<NutritionalModule4QuizPage />} />
          <Route path="learn/nutritional-module-5" element={<NutritionalModule5Page />} />
          <Route path="learn/nutritional-module-5/quiz" element={<NutritionalModule5QuizPage />} />
          <Route path="learn/nutritional-module-6" element={<NutritionalModule6Page />} />
          <Route path="learn/nutritional-module-6/quiz" element={<NutritionalModule6QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-1" element={<EmotioPsychoRationalModule1Page />} />
          <Route path="learn/emotio-psycho-rational-module-1/quiz" element={<EmotioPsychoRationalModule1QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-2" element={<EmotioPsychoRationalModule2Page />} />
          <Route path="learn/emotio-psycho-rational-module-2/quiz" element={<EmotioPsychoRationalModule2QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-3" element={<EmotioPsychoRationalModule3Page />} />
          <Route path="learn/emotio-psycho-rational-module-3/quiz" element={<EmotioPsychoRationalModule3QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-4" element={<EmotioPsychoRationalModule4Page />} />
          <Route path="learn/emotio-psycho-rational-module-4/quiz" element={<EmotioPsychoRationalModule4QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-5" element={<EmotioPsychoRationalModule5Page />} />
          <Route path="learn/emotio-psycho-rational-module-5/quiz" element={<EmotioPsychoRationalModule5QuizPage />} />
          <Route path="learn/physical-resources" element={<PhysicalResourcesPage />} />
          <Route path="learn/physical-module-1" element={<PhysicalModule1Page />} />
          <Route path="learn/physical-module-1/quiz" element={<PhysicalModule1QuizPage />} />
          <Route path="learn/physical-module-2" element={<PhysicalModule2Page />} />
          <Route path="learn/physical-module-2/quiz" element={<PhysicalModule2QuizPage />} />
          <Route path="learn/physical-module-3" element={<PhysicalModule3Page />} />
          <Route path="learn/physical-module-3/quiz" element={<PhysicalModule3QuizPage />} />
          <Route path="learn/occupational-resources" element={<OccupationalResourcesPage />} />
          <Route path="learn/occupational-module-1" element={<OccupationalModule1Page />} />
          <Route path="learn/occupational-module-2" element={<OccupationalModule2Page />} />
          <Route path="learn/occupational-module-3" element={<OccupationalModule3Page />} />
          <Route path="learn/occupational-module-4" element={<OccupationalModule4Page />} />
          <Route path="learn/occupational-module-5" element={<OccupationalModule5Page />} />
          <Route path="learn/occupational-module-1/quiz" element={<OccupationalModule1QuizPage />} />
          <Route path="learn/occupational-module-2/quiz" element={<OccupationalModule2QuizPage />} />
          <Route path="learn/occupational-module-3/quiz" element={<OccupationalModule3QuizPage />} />
          <Route path="learn/occupational-module-4/quiz" element={<OccupationalModule4QuizPage />} />
          <Route path="learn/occupational-module-5/quiz" element={<OccupationalModule5QuizPage />} />
          <Route path="learn/legendarial-resources" element={<LegendarialResourcesPage />} />
          <Route path="learn/legendarial-module-1" element={<LegendarialModule1Page />} />
          <Route path="learn/legendarial-module-2" element={<LegendarialModule2Page />} />
          <Route path="learn/legendarial-module-3" element={<LegendarialModule3Page />} />
          <Route path="learn/legendarial-module-4" element={<LegendarialModule4Page />} />
          <Route path="learn/legendarial-module-5" element={<LegendarialModule5Page />} />
          <Route path="learn/legendarial-module-1/quiz" element={<LegendarialModule1QuizPage />} />
          <Route path="learn/legendarial-module-2/quiz" element={<LegendarialModule2QuizPage />} />
          <Route path="learn/legendarial-module-3/quiz" element={<LegendarialModule3QuizPage />} />
          <Route path="learn/legendarial-module-4/quiz" element={<LegendarialModule4QuizPage />} />
          <Route path="learn/legendarial-module-5/quiz" element={<LegendarialModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-resources" element={<ReligioTraditioCulturalResourcesPage />} />
          <Route path="learn/religio-traditio-cultural-module-1" element={<ReligioTraditioCulturalModule1Page />} />
          <Route path="learn/religio-traditio-cultural-module-2" element={<ReligioTraditioCulturalModule2Page />} />
          <Route path="learn/religio-traditio-cultural-module-3" element={<ReligioTraditioCulturalModule3Page />} />
          <Route path="learn/religio-traditio-cultural-module-4" element={<ReligioTraditioCulturalModule4Page />} />
          <Route path="learn/religio-traditio-cultural-module-5" element={<ReligioTraditioCulturalModule5Page />} />
          <Route path="learn/religio-traditio-cultural-module-6" element={<ReligioTraditioCulturalModule6Page />} />
          <Route path="learn/religio-traditio-cultural-module-1/quiz" element={<ReligioTraditioCulturalModule1QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-2/quiz" element={<ReligioTraditioCulturalModule2QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-3/quiz" element={<ReligioTraditioCulturalModule3QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-4/quiz" element={<ReligioTraditioCulturalModule4QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-5/quiz" element={<ReligioTraditioCulturalModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-6/quiz" element={<ReligioTraditioCulturalModule6QuizPage />} />
          <Route path="learn/socio-relational-resources" element={<SocioRelationalResourcesPage />} />
          <Route path="learn/socio-relational-module-1" element={<SocioRelationalModule1Page />} />
          <Route path="learn/socio-relational-module-2" element={<SocioRelationalModule2Page />} />
          <Route path="learn/socio-relational-module-3" element={<SocioRelationalModule3Page />} />
          <Route path="learn/socio-relational-module-4" element={<SocioRelationalModule4Page />} />
          <Route path="learn/socio-relational-module-5" element={<SocioRelationalModule5Page />} />
          <Route path="learn/socio-relational-module-1/quiz" element={<SocioRelationalModule1QuizPage />} />
          <Route path="learn/socio-relational-module-2/quiz" element={<SocioRelationalModule2QuizPage />} />
          <Route path="learn/socio-relational-module-3/quiz" element={<SocioRelationalModule3QuizPage />} />
          <Route path="learn/socio-relational-module-4/quiz" element={<SocioRelationalModule4QuizPage />} />
          <Route path="learn/socio-relational-module-5/quiz" element={<SocioRelationalModule5QuizPage />} />
          <Route path="learn/financial-resources" element={<FinancialResourcesPage />} />
          <Route path="learn/financial-module-1" element={<FinancialModule1Page />} />
          <Route path="learn/financial-module-2" element={<FinancialModule2Page />} />
          <Route path="learn/financial-module-3" element={<FinancialModule3Page />} />
          <Route path="learn/financial-module-4" element={<FinancialModule4Page />} />
          <Route path="learn/financial-module-5" element={<FinancialModule5Page />} />
          <Route path="learn/financial-module-1/quiz" element={<FinancialModule1QuizPage />} />
          <Route path="learn/financial-module-2/quiz" element={<FinancialModule2QuizPage />} />
          <Route path="learn/financial-module-3/quiz" element={<FinancialModule3QuizPage />} />
          <Route path="learn/financial-module-4/quiz" element={<FinancialModule4QuizPage />} />
          <Route path="learn/financial-module-5/quiz" element={<FinancialModule5QuizPage />} />
          <Route path="learn/environmental-resources" element={<EnvironmentalResourcesPage />} />
          <Route path="learn/environmental-module-1" element={<EnvironmentalModule1Page />} />
          <Route path="learn/environmental-module-2" element={<EnvironmentalModule2Page />} />
          <Route path="learn/environmental-module-3" element={<EnvironmentalModule3Page />} />
          <Route path="learn/environmental-module-4" element={<EnvironmentalModule4Page />} />
          <Route path="learn/environmental-module-5" element={<EnvironmentalModule5Page />} />
          <Route path="learn/environmental-module-6" element={<EnvironmentalModule6Page />} />
          <Route path="learn/environmental-module-1/quiz" element={<EnvironmentalModule1QuizPage />} />
          <Route path="learn/environmental-module-2/quiz" element={<EnvironmentalModule2QuizPage />} />
          <Route path="learn/environmental-module-3/quiz" element={<EnvironmentalModule3QuizPage />} />
          <Route path="learn/environmental-module-4/quiz" element={<EnvironmentalModule4QuizPage />} />
          <Route path="learn/environmental-module-5/quiz" element={<EnvironmentalModule5QuizPage />} />
          <Route path="learn/environmental-module-6/quiz" element={<EnvironmentalModule6QuizPage />} />
          <Route path="learn/healthy-eating-habits" element={<HealthyEatingHabitsPage/>} />
          <Route path="learn/healthy-eating-module-1" element={<HealthyEatingModule1Page/>} />
          <Route path="learn/healthy-eating-module-2" element={<HealthyEatingModule2Page/>} />
          <Route path="learn/healthy-eating-module-3" element={<HealthyEatingModule3Page/>} />
          <Route path="learn/healthy-eating-module-4" element={<HealthyEatingModule4Page/>} />
          <Route path="learn/financial-planning" element={<FinancialPlanningResourcePage/>} />
          <Route path="learn/financial-planning/module-1" element={<FinancialPlanningModule1Page/>} />
          <Route path="learn/financial-planning/module-2" element={<FinancialPlanningModule2Page/>} />
          <Route path="learn/financial-planning/module-3" element={<FinancialPlanningModule3Page/>} />
          <Route path="learn/physical-wellness-assessment" element={<PhysicalWellnessLearnAssessmentPage/>} />
          <Route path="learn/physical-wellness-assessment/completion" element={<PhysicalWellnessLearnAssessmentCompletionPage/>} />
          <Route path="learn/general-physical-assessment/completion" element={<GeneralPhysicalAssessmentCompletionPage/>} />
          <Route path="learn/ipaq-sf-assessment/completion" element={<IPAQSFAssessmentCompletionPage/>} />
          <Route path="learn/psqi-assessment/completion" element={<PSQIAssessmentCompletionPage/>} />
          <Route path="learn/assessments" element={<AssessmentsPage/>} />
          <Route path="learn/ground-work" element={<GroundWorkPage/>} />
          <Route path="consultations" element={<ConsultationsPage/>} />
          <Route path="group-list" element={<GroupListPage/>} />
          <Route path="data-permissions" element={<DataPermissionsPage/>} />
          <Route path="profile" element={<ProfilePage isDeveloper={isDeveloper} setIsDeveloper={setIsDeveloper}/>} />
          <Route path="profile/details" element={<UserDetailedProfilePage/>} />
          <Route path="subscription" element={<SubscriptionPage/>} />
          <Route path="billing-history" element={<BillingHistoryPage/>} />
          <Route path="payment/setup" element={<PaymentSetupPage/>} />
          <Route path="learn/spiritual-module-1" element={<SpiritualModule1Page/>} />
          <Route path="learn/spiritual-module-2" element={<SpiritualModule2Page/>} />
          <Route path="learn/spiritual-module-3" element={<SpiritualModule3Page/>} />
          <Route path="learn/spiritual-module-4" element={<SpiritualModule4Page/>} />
          <Route path="learn/spiritual-module-5" element={<SpiritualModule5Page/>} />
          <Route path="learn/spiritual-module-6" element={<SpiritualModule6Page/>} />
          <Route path="learn/spiritual-module-7" element={<SpiritualModule7Page/>} />
          <Route path="learn/spiritual-module-1/quiz" element={<SpiritualModule1QuizPage/>} />
          <Route path="learn/spiritual-module-2/quiz" element={<SpiritualModule2QuizPage/>} />
          <Route path="learn/spiritual-module-3/quiz" element={<SpiritualModule3QuizPage/>} />
          <Route path="learn/spiritual-module-4/quiz" element={<SpiritualModule4QuizPage/>} />
          <Route path="learn/spiritual-module-5/quiz" element={<SpiritualModule5QuizPage/>} />
          <Route path="learn/spiritual-module-6/quiz" element={<SpiritualModule6QuizPage/>} />
          <Route path="learn/spiritual-module-7/quiz" element={<SpiritualModule7QuizPage/>} />
          <Route path="learn/nutritional-resources" element={<NutritionalResourcesPage/>} />
          <Route path="learn/emotio-psycho-rational-resources" element={<EmotioPsychoRationalResourcesPage/>} />
          <Route path="learn/nutritional-module-1" element={<NutritionalModule1Page />} />
          <Route path="learn/nutritional-module-1/quiz" element={<NutritionalModule1QuizPage />} />
          <Route path="learn/nutritional-module-2" element={<NutritionalModule2Page />} />
          <Route path="learn/nutritional-module-2/quiz" element={<NutritionalModule2QuizPage />} />
          <Route path="learn/nutritional-module-3" element={<NutritionalModule3Page />} />
          <Route path="learn/nutritional-module-3/quiz" element={<NutritionalModule3QuizPage />} />
          <Route path="learn/nutritional-module-4" element={<NutritionalModule4Page />} />
          <Route path="learn/nutritional-module-4/quiz" element={<NutritionalModule4QuizPage />} />
          <Route path="learn/nutritional-module-5" element={<NutritionalModule5Page />} />
          <Route path="learn/nutritional-module-5/quiz" element={<NutritionalModule5QuizPage />} />
          <Route path="learn/nutritional-module-6" element={<NutritionalModule6Page />} />
          <Route path="learn/nutritional-module-6/quiz" element={<NutritionalModule6QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-1" element={<EmotioPsychoRationalModule1Page />} />
          <Route path="learn/emotio-psycho-rational-module-1/quiz" element={<EmotioPsychoRationalModule1QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-2" element={<EmotioPsychoRationalModule2Page />} />
          <Route path="learn/emotio-psycho-rational-module-2/quiz" element={<EmotioPsychoRationalModule2QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-3" element={<EmotioPsychoRationalModule3Page />} />
          <Route path="learn/emotio-psycho-rational-module-3/quiz" element={<EmotioPsychoRationalModule3QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-4" element={<EmotioPsychoRationalModule4Page />} />
          <Route path="learn/emotio-psycho-rational-module-4/quiz" element={<EmotioPsychoRationalModule4QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-5" element={<EmotioPsychoRationalModule5Page />} />
          <Route path="learn/emotio-psycho-rational-module-5/quiz" element={<EmotioPsychoRationalModule5QuizPage />} />
          <Route path="learn/physical-resources" element={<PhysicalResourcesPage />} />
          <Route path="learn/physical-module-1" element={<PhysicalModule1Page />} />
          <Route path="learn/physical-module-1/quiz" element={<PhysicalModule1QuizPage />} />
          <Route path="learn/physical-module-2" element={<PhysicalModule2Page />} />
          <Route path="learn/physical-module-2/quiz" element={<PhysicalModule2QuizPage />} />
          <Route path="learn/physical-module-3" element={<PhysicalModule3Page />} />
          <Route path="learn/physical-module-3/quiz" element={<PhysicalModule3QuizPage />} />
          <Route path="learn/occupational-resources" element={<OccupationalResourcesPage />} />
          <Route path="learn/occupational-module-1" element={<OccupationalModule1Page />} />
          <Route path="learn/occupational-module-2" element={<OccupationalModule2Page />} />
          <Route path="learn/occupational-module-3" element={<OccupationalModule3Page />} />
          <Route path="learn/occupational-module-4" element={<OccupationalModule4Page />} />
          <Route path="learn/occupational-module-5" element={<OccupationalModule5Page />} />
          <Route path="learn/occupational-module-1/quiz" element={<OccupationalModule1QuizPage />} />
          <Route path="learn/occupational-module-2/quiz" element={<OccupationalModule2QuizPage />} />
          <Route path="learn/occupational-module-3/quiz" element={<OccupationalModule3QuizPage />} />
          <Route path="learn/occupational-module-4/quiz" element={<OccupationalModule4QuizPage />} />
          <Route path="learn/occupational-module-5/quiz" element={<OccupationalModule5QuizPage />} />
          <Route path="learn/legendarial-resources" element={<LegendarialResourcesPage />} />
          <Route path="learn/legendarial-module-1" element={<LegendarialModule1Page />} />
          <Route path="learn/legendarial-module-2" element={<LegendarialModule2Page />} />
          <Route path="learn/legendarial-module-3" element={<LegendarialModule3Page />} />
          <Route path="learn/legendarial-module-4" element={<LegendarialModule4Page />} />
          <Route path="learn/legendarial-module-5" element={<LegendarialModule5Page />} />
          <Route path="learn/legendarial-module-1/quiz" element={<LegendarialModule1QuizPage />} />
          <Route path="learn/legendarial-module-2/quiz" element={<LegendarialModule2QuizPage />} />
          <Route path="learn/legendarial-module-3/quiz" element={<LegendarialModule3QuizPage />} />
          <Route path="learn/legendarial-module-4/quiz" element={<LegendarialModule4QuizPage />} />
          <Route path="learn/legendarial-module-5/quiz" element={<LegendarialModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-resources" element={<ReligioTraditioCulturalResourcesPage />} />
          <Route path="learn/religio-traditio-cultural-module-1" element={<ReligioTraditioCulturalModule1Page />} />
          <Route path="learn/religio-traditio-cultural-module-2" element={<ReligioTraditioCulturalModule2Page />} />
          <Route path="learn/religio-traditio-cultural-module-3" element={<ReligioTraditioCulturalModule3Page />} />
          <Route path="learn/religio-traditio-cultural-module-4" element={<ReligioTraditioCulturalModule4Page />} />
          <Route path="learn/religio-traditio-cultural-module-5" element={<ReligioTraditioCulturalModule5Page />} />
          <Route path="learn/religio-traditio-cultural-module-6" element={<ReligioTraditioCulturalModule6Page />} />
          <Route path="learn/religio-traditio-cultural-module-1/quiz" element={<ReligioTraditioCulturalModule1QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-2/quiz" element={<ReligioTraditioCulturalModule2QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-3/quiz" element={<ReligioTraditioCulturalModule3QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-4/quiz" element={<ReligioTraditioCulturalModule4QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-5/quiz" element={<ReligioTraditioCulturalModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-6/quiz" element={<ReligioTraditioCulturalModule6QuizPage />} />
          <Route path="learn/socio-relational-resources" element={<SocioRelationalResourcesPage />} />
          <Route path="learn/socio-relational-module-1" element={<SocioRelationalModule1Page />} />
          <Route path="learn/socio-relational-module-2" element={<SocioRelationalModule2Page />} />
          <Route path="learn/socio-relational-module-3" element={<SocioRelationalModule3Page />} />
          <Route path="learn/socio-relational-module-4" element={<SocioRelationalModule4Page />} />
          <Route path="learn/socio-relational-module-5" element={<SocioRelationalModule5Page />} />
          <Route path="learn/socio-relational-module-1/quiz" element={<SocioRelationalModule1QuizPage />} />
          <Route path="learn/socio-relational-module-2/quiz" element={<SocioRelationalModule2QuizPage />} />
          <Route path="learn/socio-relational-module-3/quiz" element={<SocioRelationalModule3QuizPage />} />
          <Route path="learn/socio-relational-module-4/quiz" element={<SocioRelationalModule4QuizPage />} />
          <Route path="learn/socio-relational-module-5/quiz" element={<SocioRelationalModule5QuizPage />} />
          <Route path="learn/financial-resources" element={<FinancialResourcesPage />} />
          <Route path="learn/financial-module-1" element={<FinancialModule1Page />} />
          <Route path="learn/financial-module-2" element={<FinancialModule2Page />} />
          <Route path="learn/financial-module-3" element={<FinancialModule3Page />} />
          <Route path="learn/financial-module-4" element={<FinancialModule4Page />} />
          <Route path="learn/financial-module-5" element={<FinancialModule5Page />} />
          <Route path="learn/financial-module-1/quiz" element={<FinancialModule1QuizPage />} />
          <Route path="learn/financial-module-2/quiz" element={<FinancialModule2QuizPage />} />
          <Route path="learn/financial-module-3/quiz" element={<FinancialModule3QuizPage />} />
          <Route path="learn/financial-module-4/quiz" element={<FinancialModule4QuizPage />} />
          <Route path="learn/financial-module-5/quiz" element={<FinancialModule5QuizPage />} />
          <Route path="learn/environmental-resources" element={<EnvironmentalResourcesPage />} />
          <Route path="learn/environmental-module-1" element={<EnvironmentalModule1Page />} />
          <Route path="learn/environmental-module-2" element={<EnvironmentalModule2Page />} />
          <Route path="learn/environmental-module-3" element={<EnvironmentalModule3Page />} />
          <Route path="learn/environmental-module-4" element={<EnvironmentalModule4Page />} />
          <Route path="learn/environmental-module-5" element={<EnvironmentalModule5Page />} />
          <Route path="learn/environmental-module-6" element={<EnvironmentalModule6Page />} />
          <Route path="learn/environmental-module-1/quiz" element={<EnvironmentalModule1QuizPage />} />
          <Route path="learn/environmental-module-2/quiz" element={<EnvironmentalModule2QuizPage />} />
          <Route path="learn/environmental-module-3/quiz" element={<EnvironmentalModule3QuizPage />} />
          <Route path="learn/environmental-module-4/quiz" element={<EnvironmentalModule4QuizPage />} />
          <Route path="learn/environmental-module-5/quiz" element={<EnvironmentalModule5QuizPage />} />
          <Route path="learn/environmental-module-6/quiz" element={<EnvironmentalModule6QuizPage />} />
          <Route path="learn/healthy-eating-habits" element={<HealthyEatingHabitsPage/>} />
          <Route path="learn/healthy-eating-module-1" element={<HealthyEatingModule1Page/>} />
          <Route path="learn/healthy-eating-module-2" element={<HealthyEatingModule2Page/>} />
          <Route path="learn/healthy-eating-module-3" element={<HealthyEatingModule3Page/>} />
          <Route path="learn/healthy-eating-module-4" element={<HealthyEatingModule4Page/>} />
          <Route path="learn/financial-planning" element={<FinancialPlanningResourcePage/>} />
          <Route path="learn/financial-planning/module-1" element={<FinancialPlanningModule1Page/>} />
          <Route path="learn/financial-planning/module-2" element={<FinancialPlanningModule2Page/>} />
          <Route path="learn/financial-planning/module-3" element={<FinancialPlanningModule3Page/>} />
          <Route path="learn/physical-wellness-assessment" element={<PhysicalWellnessLearnAssessmentPage/>} />
          <Route path="learn/physical-wellness-assessment/completion" element={<PhysicalWellnessLearnAssessmentCompletionPage/>} />
          <Route path="learn/general-physical-assessment/completion" element={<GeneralPhysicalAssessmentCompletionPage/>} />
          <Route path="learn/ipaq-sf-assessment/completion" element={<IPAQSFAssessmentCompletionPage/>} />
          <Route path="learn/psqi-assessment/completion" element={<PSQIAssessmentCompletionPage/>} />
          <Route path="learn/assessments" element={<AssessmentsPage/>} />
          <Route path="learn/ground-work" element={<GroundWorkPage/>} />
          <Route path="consultations" element={<ConsultationsPage/>} />
          <Route path="group-list" element={<GroupListPage/>} />
          <Route path="data-permissions" element={<DataPermissionsPage/>} />
          <Route path="profile" element={<ProfilePage isDeveloper={isDeveloper} setIsDeveloper={setIsDeveloper}/>} />
          <Route path="profile/details" element={<UserDetailedProfilePage/>} />
          <Route path="subscription" element={<SubscriptionPage/>} />
          <Route path="billing-history" element={<BillingHistoryPage/>} />
          <Route path="payment/setup" element={<PaymentSetupPage/>} />
          <Route path="learn/spiritual-module-1" element={<SpiritualModule1Page/>} />
          <Route path="learn/spiritual-module-2" element={<SpiritualModule2Page/>} />
          <Route path="learn/spiritual-module-3" element={<SpiritualModule3Page/>} />
          <Route path="learn/spiritual-module-4" element={<SpiritualModule4Page/>} />
          <Route path="learn/spiritual-module-5" element={<SpiritualModule5Page/>} />
          <Route path="learn/spiritual-module-6" element={<SpiritualModule6Page/>} />
          <Route path="learn/spiritual-module-7" element={<SpiritualModule7Page/>} />
          <Route path="learn/spiritual-module-1/quiz" element={<SpiritualModule1QuizPage/>} />
          <Route path="learn/spiritual-module-2/quiz" element={<SpiritualModule2QuizPage/>} />
          <Route path="learn/spiritual-module-3/quiz" element={<SpiritualModule3QuizPage/>} />
          <Route path="learn/spiritual-module-4/quiz" element={<SpiritualModule4QuizPage/>} />
          <Route path="learn/spiritual-module-5/quiz" element={<SpiritualModule5QuizPage/>} />
          <Route path="learn/spiritual-module-6/quiz" element={<SpiritualModule6QuizPage/>} />
          <Route path="learn/spiritual-module-7/quiz" element={<SpiritualModule7QuizPage/>} />
          <Route path="learn/nutritional-resources" element={<NutritionalResourcesPage/>} />
          <Route path="learn/emotio-psycho-rational-resources" element={<EmotioPsychoRationalResourcesPage/>} />
          <Route path="learn/nutritional-module-1" element={<NutritionalModule1Page />} />
          <Route path="learn/nutritional-module-1/quiz" element={<NutritionalModule1QuizPage />} />
          <Route path="learn/nutritional-module-2" element={<NutritionalModule2Page />} />
          <Route path="learn/nutritional-module-2/quiz" element={<NutritionalModule2QuizPage />} />
          <Route path="learn/nutritional-module-3" element={<NutritionalModule3Page />} />
          <Route path="learn/nutritional-module-3/quiz" element={<NutritionalModule3QuizPage />} />
          <Route path="learn/nutritional-module-4" element={<NutritionalModule4Page />} />
          <Route path="learn/nutritional-module-4/quiz" element={<NutritionalModule4QuizPage />} />
          <Route path="learn/nutritional-module-5" element={<NutritionalModule5Page />} />
          <Route path="learn/nutritional-module-5/quiz" element={<NutritionalModule5QuizPage />} />
          <Route path="learn/nutritional-module-6" element={<NutritionalModule6Page />} />
          <Route path="learn/nutritional-module-6/quiz" element={<NutritionalModule6QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-1" element={<EmotioPsychoRationalModule1Page />} />
          <Route path="learn/emotio-psycho-rational-module-1/quiz" element={<EmotioPsychoRationalModule1QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-2" element={<EmotioPsychoRationalModule2Page />} />
          <Route path="learn/emotio-psycho-rational-module-2/quiz" element={<EmotioPsychoRationalModule2QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-3" element={<EmotioPsychoRationalModule3Page />} />
          <Route path="learn/emotio-psycho-rational-module-3/quiz" element={<EmotioPsychoRationalModule3QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-4" element={<EmotioPsychoRationalModule4Page />} />
          <Route path="learn/emotio-psycho-rational-module-4/quiz" element={<EmotioPsychoRationalModule4QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-5" element={<EmotioPsychoRationalModule5Page />} />
          <Route path="learn/emotio-psycho-rational-module-5/quiz" element={<EmotioPsychoRationalModule5QuizPage />} />
          <Route path="learn/physical-resources" element={<PhysicalResourcesPage />} />
          <Route path="learn/physical-module-1" element={<PhysicalModule1Page />} />
          <Route path="learn/physical-module-1/quiz" element={<PhysicalModule1QuizPage />} />
          <Route path="learn/physical-module-2" element={<PhysicalModule2Page />} />
          <Route path="learn/physical-module-2/quiz" element={<PhysicalModule2QuizPage />} />
          <Route path="learn/physical-module-3" element={<PhysicalModule3Page />} />
          <Route path="learn/physical-module-3/quiz" element={<PhysicalModule3QuizPage />} />
          <Route path="learn/occupational-resources" element={<OccupationalResourcesPage />} />
          <Route path="learn/occupational-module-1" element={<OccupationalModule1Page />} />
          <Route path="learn/occupational-module-2" element={<OccupationalModule2Page />} />
          <Route path="learn/occupational-module-3" element={<OccupationalModule3Page />} />
          <Route path="learn/occupational-module-4" element={<OccupationalModule4Page />} />
          <Route path="learn/occupational-module-5" element={<OccupationalModule5Page />} />
          <Route path="learn/occupational-module-1/quiz" element={<OccupationalModule1QuizPage />} />
          <Route path="learn/occupational-module-2/quiz" element={<OccupationalModule2QuizPage />} />
          <Route path="learn/occupational-module-3/quiz" element={<OccupationalModule3QuizPage />} />
          <Route path="learn/occupational-module-4/quiz" element={<OccupationalModule4QuizPage />} />
          <Route path="learn/occupational-module-5/quiz" element={<OccupationalModule5QuizPage />} />
          <Route path="learn/legendarial-resources" element={<LegendarialResourcesPage />} />
          <Route path="learn/legendarial-module-1" element={<LegendarialModule1Page />} />
          <Route path="learn/legendarial-module-2" element={<LegendarialModule2Page />} />
          <Route path="learn/legendarial-module-3" element={<LegendarialModule3Page />} />
          <Route path="learn/legendarial-module-4" element={<LegendarialModule4Page />} />
          <Route path="learn/legendarial-module-5" element={<LegendarialModule5Page />} />
          <Route path="learn/legendarial-module-1/quiz" element={<LegendarialModule1QuizPage />} />
          <Route path="learn/legendarial-module-2/quiz" element={<LegendarialModule2QuizPage />} />
          <Route path="learn/legendarial-module-3/quiz" element={<LegendarialModule3QuizPage />} />
          <Route path="learn/legendarial-module-4/quiz" element={<LegendarialModule4QuizPage />} />
          <Route path="learn/legendarial-module-5/quiz" element={<LegendarialModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-resources" element={<ReligioTraditioCulturalResourcesPage />} />
          <Route path="learn/religio-traditio-cultural-module-1" element={<ReligioTraditioCulturalModule1Page />} />
          <Route path="learn/religio-traditio-cultural-module-2" element={<ReligioTraditioCulturalModule2Page />} />
          <Route path="learn/religio-traditio-cultural-module-3" element={<ReligioTraditioCulturalModule3Page />} />
          <Route path="learn/religio-traditio-cultural-module-4" element={<ReligioTraditioCulturalModule4Page />} />
          <Route path="learn/religio-traditio-cultural-module-5" element={<ReligioTraditioCulturalModule5Page />} />
          <Route path="learn/religio-traditio-cultural-module-6" element={<ReligioTraditioCulturalModule6Page />} />
          <Route path="learn/religio-traditio-cultural-module-1/quiz" element={<ReligioTraditioCulturalModule1QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-2/quiz" element={<ReligioTraditioCulturalModule2QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-3/quiz" element={<ReligioTraditioCulturalModule3QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-4/quiz" element={<ReligioTraditioCulturalModule4QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-5/quiz" element={<ReligioTraditioCulturalModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-6/quiz" element={<ReligioTraditioCulturalModule6QuizPage />} />
          <Route path="learn/socio-relational-resources" element={<SocioRelationalResourcesPage />} />
          <Route path="learn/socio-relational-module-1" element={<SocioRelationalModule1Page />} />
          <Route path="learn/socio-relational-module-2" element={<SocioRelationalModule2Page />} />
          <Route path="learn/socio-relational-module-3" element={<SocioRelationalModule3Page />} />
          <Route path="learn/socio-relational-module-4" element={<SocioRelationalModule4Page />} />
          <Route path="learn/socio-relational-module-5" element={<SocioRelationalModule5Page />} />
          <Route path="learn/socio-relational-module-1/quiz" element={<SocioRelationalModule1QuizPage />} />
          <Route path="learn/socio-relational-module-2/quiz" element={<SocioRelationalModule2QuizPage />} />
          <Route path="learn/socio-relational-module-3/quiz" element={<SocioRelationalModule3QuizPage />} />
          <Route path="learn/socio-relational-module-4/quiz" element={<SocioRelationalModule4QuizPage />} />
          <Route path="learn/socio-relational-module-5/quiz" element={<SocioRelationalModule5QuizPage />} />
          <Route path="learn/financial-resources" element={<FinancialResourcesPage />} />
          <Route path="learn/financial-module-1" element={<FinancialModule1Page />} />
          <Route path="learn/financial-module-2" element={<FinancialModule2Page />} />
          <Route path="learn/financial-module-3" element={<FinancialModule3Page />} />
          <Route path="learn/financial-module-4" element={<FinancialModule4Page />} />
          <Route path="learn/financial-module-5" element={<FinancialModule5Page />} />
          <Route path="learn/financial-module-1/quiz" element={<FinancialModule1QuizPage />} />
          <Route path="learn/financial-module-2/quiz" element={<FinancialModule2QuizPage />} />
          <Route path="learn/financial-module-3/quiz" element={<FinancialModule3QuizPage />} />
          <Route path="learn/financial-module-4/quiz" element={<FinancialModule4QuizPage />} />
          <Route path="learn/financial-module-5/quiz" element={<FinancialModule5QuizPage />} />
          <Route path="learn/environmental-resources" element={<EnvironmentalResourcesPage />} />
          <Route path="learn/environmental-module-1" element={<EnvironmentalModule1Page />} />
          <Route path="learn/environmental-module-2" element={<EnvironmentalModule2Page />} />
          <Route path="learn/environmental-module-3" element={<EnvironmentalModule3Page />} />
          <Route path="learn/environmental-module-4" element={<EnvironmentalModule4Page />} />
          <Route path="learn/environmental-module-5" element={<EnvironmentalModule5Page />} />
          <Route path="learn/environmental-module-6" element={<EnvironmentalModule6Page />} />
          <Route path="learn/environmental-module-1/quiz" element={<EnvironmentalModule1QuizPage />} />
          <Route path="learn/environmental-module-2/quiz" element={<EnvironmentalModule2QuizPage />} />
          <Route path="learn/environmental-module-3/quiz" element={<EnvironmentalModule3QuizPage />} />
          <Route path="learn/environmental-module-4/quiz" element={<EnvironmentalModule4QuizPage />} />
          <Route path="learn/environmental-module-5/quiz" element={<EnvironmentalModule5QuizPage />} />
          <Route path="learn/environmental-module-6/quiz" element={<EnvironmentalModule6QuizPage />} />
          <Route path="learn/healthy-eating-habits" element={<HealthyEatingHabitsPage/>} />
          <Route path="learn/healthy-eating-module-1" element={<HealthyEatingModule1Page/>} />
          <Route path="learn/healthy-eating-module-2" element={<HealthyEatingModule2Page/>} />
          <Route path="learn/healthy-eating-module-3" element={<HealthyEatingModule3Page/>} />
          <Route path="learn/healthy-eating-module-4" element={<HealthyEatingModule4Page/>} />
          <Route path="learn/financial-planning" element={<FinancialPlanningResourcePage/>} />
          <Route path="learn/financial-planning/module-1" element={<FinancialPlanningModule1Page/>} />
          <Route path="learn/financial-planning/module-2" element={<FinancialPlanningModule2Page/>} />
          <Route path="learn/financial-planning/module-3" element={<FinancialPlanningModule3Page/>} />
          <Route path="learn/physical-wellness-assessment" element={<PhysicalWellnessLearnAssessmentPage/>} />
          <Route path="learn/physical-wellness-assessment/completion" element={<PhysicalWellnessLearnAssessmentCompletionPage/>} />
          <Route path="learn/general-physical-assessment/completion" element={<GeneralPhysicalAssessmentCompletionPage/>} />
          <Route path="learn/ipaq-sf-assessment/completion" element={<IPAQSFAssessmentCompletionPage/>} />
          <Route path="learn/psqi-assessment/completion" element={<PSQIAssessmentCompletionPage/>} />
          <Route path="learn/assessments" element={<AssessmentsPage/>} />
          <Route path="learn/ground-work" element={<GroundWorkPage/>} />
          <Route path="consultations" element={<ConsultationsPage/>} />
          <Route path="group-list" element={<GroupListPage/>} />
          <Route path="data-permissions" element={<DataPermissionsPage/>} />
          <Route path="profile" element={<ProfilePage isDeveloper={isDeveloper} setIsDeveloper={setIsDeveloper}/>} />
          <Route path="profile/details" element={<UserDetailedProfilePage/>} />
          <Route path="subscription" element={<SubscriptionPage/>} />
          <Route path="billing-history" element={<BillingHistoryPage/>} />
          <Route path="payment/setup" element={<PaymentSetupPage/>} />
          <Route path="learn/spiritual-module-1" element={<SpiritualModule1Page/>} />
          <Route path="learn/spiritual-module-2" element={<SpiritualModule2Page/>} />
          <Route path="learn/spiritual-module-3" element={<SpiritualModule3Page/>} />
          <Route path="learn/spiritual-module-4" element={<SpiritualModule4Page/>} />
          <Route path="learn/spiritual-module-5" element={<SpiritualModule5Page/>} />
          <Route path="learn/spiritual-module-6" element={<SpiritualModule6Page/>} />
          <Route path="learn/spiritual-module-7" element={<SpiritualModule7Page/>} />
          <Route path="learn/spiritual-module-1/quiz" element={<SpiritualModule1QuizPage/>} />
          <Route path="learn/spiritual-module-2/quiz" element={<SpiritualModule2QuizPage/>} />
          <Route path="learn/spiritual-module-3/quiz" element={<SpiritualModule3QuizPage/>} />
          <Route path="learn/spiritual-module-4/quiz" element={<SpiritualModule4QuizPage/>} />
          <Route path="learn/spiritual-module-5/quiz" element={<SpiritualModule5QuizPage/>} />
          <Route path="learn/spiritual-module-6/quiz" element={<SpiritualModule6QuizPage/>} />
          <Route path="learn/spiritual-module-7/quiz" element={<SpiritualModule7QuizPage/>} />
          <Route path="learn/nutritional-resources" element={<NutritionalResourcesPage/>} />
          <Route path="learn/emotio-psycho-rational-resources" element={<EmotioPsychoRationalResourcesPage/>} />
          <Route path="learn/nutritional-module-1" element={<NutritionalModule1Page />} />
          <Route path="learn/nutritional-module-1/quiz" element={<NutritionalModule1QuizPage />} />
          <Route path="learn/nutritional-module-2" element={<NutritionalModule2Page />} />
          <Route path="learn/nutritional-module-2/quiz" element={<NutritionalModule2QuizPage />} />
          <Route path="learn/nutritional-module-3" element={<NutritionalModule3Page />} />
          <Route path="learn/nutritional-module-3/quiz" element={<NutritionalModule3QuizPage />} />
          <Route path="learn/nutritional-module-4" element={<NutritionalModule4Page />} />
          <Route path="learn/nutritional-module-4/quiz" element={<NutritionalModule4QuizPage />} />
          <Route path="learn/nutritional-module-5" element={<NutritionalModule5Page />} />
          <Route path="learn/nutritional-module-5/quiz" element={<NutritionalModule5QuizPage />} />
          <Route path="learn/nutritional-module-6" element={<NutritionalModule6Page />} />
          <Route path="learn/nutritional-module-6/quiz" element={<NutritionalModule6QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-1" element={<EmotioPsychoRationalModule1Page />} />
          <Route path="learn/emotio-psycho-rational-module-1/quiz" element={<EmotioPsychoRationalModule1QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-2" element={<EmotioPsychoRationalModule2Page />} />
          <Route path="learn/emotio-psycho-rational-module-2/quiz" element={<EmotioPsychoRationalModule2QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-3" element={<EmotioPsychoRationalModule3Page />} />
          <Route path="learn/emotio-psycho-rational-module-3/quiz" element={<EmotioPsychoRationalModule3QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-4" element={<EmotioPsychoRationalModule4Page />} />
          <Route path="learn/emotio-psycho-rational-module-4/quiz" element={<EmotioPsychoRationalModule4QuizPage />} />
          <Route path="learn/emotio-psycho-rational-module-5" element={<EmotioPsychoRationalModule5Page />} />
          <Route path="learn/emotio-psycho-rational-module-5/quiz" element={<EmotioPsychoRationalModule5QuizPage />} />
          <Route path="learn/physical-resources" element={<PhysicalResourcesPage />} />
          <Route path="learn/physical-module-1" element={<PhysicalModule1Page />} />
          <Route path="learn/physical-module-1/quiz" element={<PhysicalModule1QuizPage />} />
          <Route path="learn/physical-module-2" element={<PhysicalModule2Page />} />
          <Route path="learn/physical-module-2/quiz" element={<PhysicalModule2QuizPage />} />
          <Route path="learn/physical-module-3" element={<PhysicalModule3Page />} />
          <Route path="learn/physical-module-3/quiz" element={<PhysicalModule3QuizPage />} />
          <Route path="learn/occupational-resources" element={<OccupationalResourcesPage />} />
          <Route path="learn/occupational-module-1" element={<OccupationalModule1Page />} />
          <Route path="learn/occupational-module-2" element={<OccupationalModule2Page />} />
          <Route path="learn/occupational-module-3" element={<OccupationalModule3Page />} />
          <Route path="learn/occupational-module-4" element={<OccupationalModule4Page />} />
          <Route path="learn/occupational-module-5" element={<OccupationalModule5Page />} />
          <Route path="learn/occupational-module-1/quiz" element={<OccupationalModule1QuizPage />} />
          <Route path="learn/occupational-module-2/quiz" element={<OccupationalModule2QuizPage />} />
          <Route path="learn/occupational-module-3/quiz" element={<OccupationalModule3QuizPage />} />
          <Route path="learn/occupational-module-4/quiz" element={<OccupationalModule4QuizPage />} />
          <Route path="learn/occupational-module-5/quiz" element={<OccupationalModule5QuizPage />} />
          <Route path="learn/legendarial-resources" element={<LegendarialResourcesPage />} />
          <Route path="learn/legendarial-module-1" element={<LegendarialModule1Page />} />
          <Route path="learn/legendarial-module-2" element={<LegendarialModule2Page />} />
          <Route path="learn/legendarial-module-3" element={<LegendarialModule3Page />} />
          <Route path="learn/legendarial-module-4" element={<LegendarialModule4Page />} />
          <Route path="learn/legendarial-module-5" element={<LegendarialModule5Page />} />
          <Route path="learn/legendarial-module-1/quiz" element={<LegendarialModule1QuizPage />} />
          <Route path="learn/legendarial-module-2/quiz" element={<LegendarialModule2QuizPage />} />
          <Route path="learn/legendarial-module-3/quiz" element={<LegendarialModule3QuizPage />} />
          <Route path="learn/legendarial-module-4/quiz" element={<LegendarialModule4QuizPage />} />
          <Route path="learn/legendarial-module-5/quiz" element={<LegendarialModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-resources" element={<ReligioTraditioCulturalResourcesPage />} />
          <Route path="learn/religio-traditio-cultural-module-1" element={<ReligioTraditioCulturalModule1Page />} />
          <Route path="learn/religio-traditio-cultural-module-2" element={<ReligioTraditioCulturalModule2Page />} />
          <Route path="learn/religio-traditio-cultural-module-3" element={<ReligioTraditioCulturalModule3Page />} />
          <Route path="learn/religio-traditio-cultural-module-4" element={<ReligioTraditioCulturalModule4Page />} />
          <Route path="learn/religio-traditio-cultural-module-5" element={<ReligioTraditioCulturalModule5Page />} />
          <Route path="learn/religio-traditio-cultural-module-6" element={<ReligioTraditioCulturalModule6Page />} />
          <Route path="learn/religio-traditio-cultural-module-1/quiz" element={<ReligioTraditioCulturalModule1QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-2/quiz" element={<ReligioTraditioCulturalModule2QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-3/quiz" element={<ReligioTraditioCulturalModule3QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-4/quiz" element={<ReligioTraditioCulturalModule4QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-5/quiz" element={<ReligioTraditioCulturalModule5QuizPage />} />
          <Route path="learn/religio-traditio-cultural-module-6/quiz" element={<ReligioTraditioCulturalModule6QuizPage />} />
          <Route path="learn/socio-relational-resources" element={<SocioRelationalResourcesPage />} />
          <Route path="learn/socio-relational-module-1" element={<SocioRelationalModule1Page />} />
        </Routes>
      </main>
    </div>
  );
}
export default Panel;